// 원본: 맞춤형 사례관리 알고리듬 목표 및 내용 추천 리스트.xlsx
// 완전한 목표-세부내용 쌍만 중복 제거하여 반영했습니다.
export const RECOMMENDATION_PAIRS = [
    {
        "goal":  "목표",
        "detail":  "내용"
    },
    {
        "goal":  "변비 해소",
        "detail":  "대상자의 변비증상 완화를 위해 락토핏을 제공한다."
    },
    {
        "goal":  "영양관리 필요성 인식",
        "detail":  "규칙적인 식사 및 수분 섭취의 중요성 교육을 제공한다."
    },
    {
        "goal":  "위생상태 향상",
        "detail":  "요실금(또는 전립선 비대증) 약물 투약 여부를 규칙적으로 확인한다."
    },
    {
        "goal":  "위생상태 향상",
        "detail":  "기저귀를 제공한다."
    },
    {
        "goal":  "운동의 중요성 인지",
        "detail":  "보호자에게 규칙적인 운동으로 근육을 키울 수 있도록 교육을 제공한다."
    },
    {
        "goal":  "운동의 중요성 인지",
        "detail":  "보호자에게 운동복 관련 주의사항 교육을 제공한다."
    },
    {
        "goal":  "질병으로 인한 고통 감소",
        "detail":  "보호자에게 요실금 생활요법 개선 및 골반 근육 운동 교육을 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "보호자에게 동반 질병에 대한 교육 및 정보를 제공한다."
    },
    {
        "goal":  "치매노인의 건강에 대한 이해도 향상",
        "detail":  "센터내 보호자 교육 제공을 제공한다."
    },
    {
        "goal":  "신체적 부담 경감으로 건강 개선",
        "detail":  "보호자에게 건강관리 상담 및 치료 연계방법을 안내한다."
    },
    {
        "goal":  "치매환자에 대한 특성을 이해하고 돌봄 향상",
        "detail":  "보호자에게 치매바로알기 정보자료 제공 및 교육을 제공한다."
    },
    {
        "goal":  "치매노인의 건강에 대한 이해도 향상",
        "detail":  "보호자에게 보건소 내 건강관련 프로그램을 안내한다."
    },
    {
        "goal":  "소지품 관리 기능 향상",
        "detail":  "자주 사용하는 물품 같은 장소에 보관하는 교육을 제공한다."
    },
    {
        "goal":  "지남력 향상",
        "detail":  "달력이나 뉴스를 통한 지남력 활동을 지원한다."
    },
    {
        "goal":  "규칙적인 식사 및 영양습관",
        "detail":  "규칙적인 식사 습관을 갖도록 교육을 제공한다."
    },
    {
        "goal":  "규칙적인 식사 및 영양습관",
        "detail":  "충분한 수분 및 식이섬유를 섭취하도록 교육을 제공한다."
    },
    {
        "goal":  "건강관리 인식 향상",
        "detail":  "통증 유발요인 파악 및 관리방법 교육을 제공한다."
    },
    {
        "goal":  "수면양상 정상화",
        "detail":  "수면양상 사정 및 비약물적 교육을 제공한다."
    },
    {
        "goal":  "음식물 관리",
        "detail":  "냉장고, 가스렌지 사용법 교육을 제공한다."
    },
    {
        "goal":  "개인위생관리 유지",
        "detail":  "위생관리 교육 및 개인 위생용품을 제공한다."
    },
    {
        "goal":  "식습관 개선",
        "detail":  "식중독 주의 교육을 제공한다."
    },
    {
        "goal":  "정해진 시간에 따른 규칙적인 생활",
        "detail":  "생활계획표 작성 교육을 제공한다."
    },
    {
        "goal":  "신체 기능 향상",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "사회활동 유지 및 증진",
        "detail":  "쉼터 이용한 활동 참여 지지 및 격려를 제공한다."
    },
    {
        "goal":  "사회적 접촉과 교류의 기회 마련",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "신체 활동능력 증가",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "현재 인지상태 유지",
        "detail":  "찾아가는 쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "사회활동 유지",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "가용범위내에서 안전하게 활동",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "우울감을 감소",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "위생상태 향상",
        "detail":  "수분 섭취 및 케겔 운동 교육을 제공한다."
    },
    {
        "goal":  "적절한 통증관리",
        "detail":  "통증 관리 방법 교육을 제공한다."
    },
    {
        "goal":  "가용범위 내에서 신체의 잔존능력 유지",
        "detail":  "실내에서 할 수 있는 치매예방건강 포스터를 제공하고 교육한다."
    },
    {
        "goal":  "가용범위 내에서 신체활동 증진",
        "detail":  "운동 보조물품을 제공한다."
    },
    {
        "goal":  "가용범위 내에서 신체활동 증진",
        "detail":  "실내 운동법에 대해 교육하고 보조물품을 제공한다."
    },
    {
        "goal":  "잔존 신체능력 유지",
        "detail":  "뇌건강 리플릿을 1회 제공한다."
    },
    {
        "goal":  "잔존 신체능력 유지",
        "detail":  "방문 시 리플릿을 활용하여 3가지 이상 함께 실시한다."
    },
    {
        "goal":  "규칙적인 실내 체조를 통해 신체의 잔존능력 유지",
        "detail":  "실내에서 할 수 있는 건강체조 포스터를 제공하고 체조 실행 여부를 모니터링한다."
    },
    {
        "goal":  "규칙적인 건강체조로 잔존 신체능력 유지",
        "detail":  "건강체조 포스터를 제공한다."
    },
    {
        "goal":  "규칙적인 건강체조로 잔존 신체능력 유지",
        "detail":  "규칙적인 체조 교육 및 관리를 제공한다."
    },
    {
        "goal":  "규칙적인 건강체조로 잔존 신체능력 유지",
        "detail":  "동네 산책과 보행운동을 안내한다."
    },
    {
        "goal":  "기력 증진",
        "detail":  "주 3회 이상 동네 산책을 할 수 있도록 독려한다."
    },
    {
        "goal":  "스스로 신체활동 수행",
        "detail":  "규칙적으로 가벼운 걷기와 같은 운동을 할 수 있도록 교육 및 격려한다."
    },
    {
        "goal":  "이동시 낙상 예방",
        "detail":  "근력과 관절 가동범위 내에서 움직임과 보행법 교육을 제공한다."
    },
    {
        "goal":  "건강관리 인식 향상",
        "detail":  "가용범위 내 신체활동 운동법 교육을 제공한다."
    },
    {
        "goal":  "가동범위 내 신체활동 생활화",
        "detail":  "신체활동교육을 제공한다."
    },
    {
        "goal":  "관절구축 및 하지근력 약화 예방",
        "detail":  "관절 가동 범위 내에서 할 수 있는 하지운동 시범보이고 지속 실천을 격려한다."
    },
    {
        "goal":  "신체활동 증진",
        "detail":  "보행보조기 신청기관 연계 제공한다."
    },
    {
        "goal":  "질병으로 인한 응급상황 발생 감소",
        "detail":  "질병으로 인한 응급상황시 대처요령 교육을 제공한다."
    },
    {
        "goal":  "관절가동범위 운동으로 근육 구축 방지",
        "detail":  "관절가동범위 운동법 교육을 제공한다."
    },
    {
        "goal":  "스스로 스트레칭",
        "detail":  "치매예방체조 포스터를 제공한다."
    },
    {
        "goal":  "주기적 산책",
        "detail":  "주기적으로 신체활동교육을 제공한다."
    },
    {
        "goal":  "치료 회복을 위해 매끼니 식사",
        "detail":  "필요한 영양섭취를 위해 영양음료를 제공한다."
    },
    {
        "goal":  "치료 회복을 위해 매끼니 식사",
        "detail":  "영양상태 개선을 위해 영양음료를 제공한다."
    },
    {
        "goal":  "부족한 영양 보충",
        "detail":  "대상자 영양 섭취를 위해 영양음료를 제공한다."
    },
    {
        "goal":  "영양 불균형 해소",
        "detail":  "균형적인 영양섭취를 위해 영양음료를 제공한다."
    },
    {
        "goal":  "균형 잡힌 식사로 필요한 영양 섭취",
        "detail":  "영양상태 개선을 위한 보조식품을 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "복지관 재가복지팀 서비스를 연계한다."
    },
    {
        "goal":  "영양소 골고루 섭취",
        "detail":  "영양보조식지원서비스를 연계한다."
    },
    {
        "goal":  "균형잡힌 식사로 필요한 영양 섭취",
        "detail":  "식사배달서비스를 연계한다."
    },
    {
        "goal":  "적절한 영양 식이관리 유지",
        "detail":  "영양죽을 제공한다."
    },
    {
        "goal":  "식사 및 가사 관리 기능 향상",
        "detail":  "식사배달 서비스를 연계한다."
    },
    {
        "goal":  "균형잡힌 영양으로 신체건강증진",
        "detail":  "영양보조식 서비스를 연계한다."
    },
    {
        "goal":  "균형잡힌 식사 실시",
        "detail":  "영양보조식 관련 정보를 제공한다."
    },
    {
        "goal":  "일상생활 유지",
        "detail":  "가스안전차단기, 정리정돈 등 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "동반질병에 대한 교육 및 정보지를 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "정기적인 협약병원 진료를 확인한다."
    },
    {
        "goal":  "신체건강 유지",
        "detail":  "협약병원과 연결한다."
    },
    {
        "goal":  "주기적인 증상관리 유지",
        "detail":  "정기진료와 처방관리 점검을 제공한다."
    },
    {
        "goal":  "스스로 스트레칭",
        "detail":  "물리치료사의 스트레칭 교육을 제공한다."
    },
    {
        "goal":  "증상에 맞는 진료받기",
        "detail":  "협약병원 정보 및 연계를 제공한다."
    },
    {
        "goal":  "수시로 침대에서 체위변경",
        "detail":  "와상상태에 따른 체위변경 및 욕창방지 예방 교육을 제공한다."
    },
    {
        "goal":  "질병으로 인한 고통 감소",
        "detail":  "노인의료돌봄통합지원사업을 연계한다."
    },
    {
        "goal":  "주기적 신체 건강 관리",
        "detail":  "노인의료돌봄통합지원시범사업을 연계한다."
    },
    {
        "goal":  "신체능력에 따른 필수적 운동 수행",
        "detail":  "통합돌봄 방문 운동지도 사업을 연계한다."
    },
    {
        "goal":  "신체 기능 향상",
        "detail":  "노인의료돌봄통합지원시범사업을 연계한다."
    },
    {
        "goal":  "주기적 병원 방문을 통한 건강상태 유지",
        "detail":  "노인의료돌봄통합지원시범사업 정보를 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "통증 유발요인 파악 및 관리방법 교육을 제공한다."
    },
    {
        "goal":  "병의원 진료를 통해 건강 유지",
        "detail":  "병의원서비스를 연계한다."
    },
    {
        "goal":  "질환관리 강화 유지",
        "detail":  "병의원서비스를 연계한다."
    },
    {
        "goal":  "새로운 질병이환 예방",
        "detail":  "고혈압약과 당뇨약 항혈전제 등을 처방받을 수 있도록 보건소 및 병원을 연계한다."
    },
    {
        "goal":  "대상자의 건강상태에 맞는 병의원 이용",
        "detail":  "지역 내 병의원 정보를 제공한다."
    },
    {
        "goal":  "앉았다 일어나기 하루 10회",
        "detail":  "보호자에게 신체활동 수행 스티커 사용법 교육을 제공한다."
    },
    {
        "goal":  "질환 관리, 심리정서 교육지원 강화",
        "detail":  "방문보건 ,정신건강 복지센터 상담 및 교육을 연계한다."
    },
    {
        "goal":  "보호자의 의사소통 기술 향상",
        "detail":  "비언어적 의사소통 방법을 교육한다."
    },
    {
        "goal":  "안전한 환경 조성",
        "detail":  "인식개선교육을 제공한다."
    },
    {
        "goal":  "보호자의 건강에 대한 지식 및 이해도 향상",
        "detail":  "노인복지관 내 건강관련 프로그램 안내한다."
    },
    {
        "goal":  "재가급여 서비스를 받기 위해 장기요양등급 신청",
        "detail":  "장기요양서비스를 신청할 수 있도록 관련 정보를 제공한다."
    },
    {
        "goal":  "재가급여 서비스를 받기 위해 장기요양등급 신청",
        "detail":  "장기요양등급 신청 방법을 안내한다."
    },
    {
        "goal":  "방문목욕 서비스로 청결 유지",
        "detail":  "장기요양기관에 대한 정보를 제공하고 연계한다."
    },
    {
        "goal":  "재가급여 서비스를 받기 위해 장기요양등급 신청",
        "detail":  "장기요양서비스(식사 및 가사 관리 기능) 관련 정보를 제공한다."
    },
    {
        "goal":  "장기요양등급 신청 연계를 통한 일상생활 수행능력 향상",
        "detail":  "일상생활 도움을 위한 방문요양서비스 신청정보를 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "가능한 돌봄서비스 확인 및 이용 독려한다."
    },
    {
        "goal":  "건강이상 시 대처 방안 마련",
        "detail":  "장기요양서비스를 연계한다."
    },
    {
        "goal":  "현 질병상태 유지하고 악화 방지",
        "detail":  "노인장기요양보험 등급 신청 및 서비스 내용에 대한 정보제공한다."
    },
    {
        "goal":  "일상생활 유지관리",
        "detail":  "장기요양 인정신청 및 서비스를 연계한다."
    },
    {
        "goal":  "신체기능 유지 증진, 외출기능 향상",
        "detail":  "주간보호센터 신체활동 프로그램을 연계한다."
    },
    {
        "goal":  "규칙적인 식생활로 건강 유지",
        "detail":  "장기요양서비스를 연계한다."
    },
    {
        "goal":  "대상자의 건강상태에 맞는 병의원 이용",
        "detail":  "장기요양서비스 안내 및 연계한다."
    },
    {
        "goal":  "질병 예방",
        "detail":  "마을회관 프로그램 정보를 제공한다."
    },
    {
        "goal":  "건강관리 인식 향상",
        "detail":  "지역 내 프로그램 안내 및 이용 독려한다."
    },
    {
        "goal":  "건강에 대한 인식 개선",
        "detail":  "지역사회건강프로그램서비스를 연계한다."
    },
    {
        "goal":  "합병증 예방",
        "detail":  "고혈압, 당뇨교실 사업을 연계한다."
    },
    {
        "goal":  "지역내 활동 강화 유지",
        "detail":  "복지관, 경로당, 생활체육회 프로그램을 연계한다."
    },
    {
        "goal":  "사회활동 참여 기회 확대",
        "detail":  "주민자치센터 서비스(건강체조교실)를 연계한다."
    },
    {
        "goal":  "보호자의 건강에 대한 지식 및 이해도 향상",
        "detail":  "지역사회건강프로그램서비스 정보를 제공한다."
    },
    {
        "goal":  "주기적 신체 건강 관리",
        "detail":  "치매관리주치의를 연계한다."
    },
    {
        "goal":  "치매환자, 가족의 질환관리 및 치매진료 유지 강화",
        "detail":  "질환관련 상담, 치매약 처방을 위한 진료를 연계한다."
    },
    {
        "goal":  "치매환자의 건강 관리",
        "detail":  "치매관리주치의를 연계한다."
    },
    {
        "goal":  "주기적 병원 방문을 통한 건강상태 유지",
        "detail":  "치매관리 주치의 정보를 제공한다."
    },
    {
        "goal":  "현 질병상태 유지 및 악화방지",
        "detail":  "치매안심병원 서비스를 연계한다."
    },
    {
        "goal":  "주기적 신체 건강 관리",
        "detail":  "치매안심병동을 연계한다."
    },
    {
        "goal":  "치매로 인한 심리정서행동관리",
        "detail":  "입원치료 연계 및 상담을 연계한다."
    },
    {
        "goal":  "주기적 병원 방문을 통한 건강상태 유지",
        "detail":  "치매안심병동 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "돌봄로봇을 활용하여 인지력 향상",
        "detail":  "인지훈련을 위해 돌봄로봇을 제공(대여)한다."
    },
    {
        "goal":  "돌봄로봇을 활용하여 인지기능 향상",
        "detail":  "돌봄 로봇 제공 확인 및 실생활 중 이용 빈도 체크한다."
    },
    {
        "goal":  "인지기능 저하로 인한 사고예방",
        "detail":  "인지기능 유지를 위한 돌봄로봇 지원한다."
    },
    {
        "goal":  "정서적 안정",
        "detail":  "돌봄로봇지원연계한다."
    },
    {
        "goal":  "지남력 유지",
        "detail":  "돌봄 로봇을 통한 지남력 훈련 제공한다."
    },
    {
        "goal":  "우울감 감소",
        "detail":  "AI 돌봄인형(효돌이) 제공한다."
    },
    {
        "goal":  "기억력 저하로 인한 일상생활의 어려움과 불편감 감소",
        "detail":  "돌봄로봇인형 지원하여 프로그램통해 일상생활건강관리 및 응급안전관리, 정서안전관리를 받을수 있도록 사용법을 안 내하고 정기적인 사용자 모니터링을 제공한다."
    },
    {
        "goal":  "돌봄로봇지원으로 인지기능 유지 및 향상",
        "detail":  "돌봄로봇을 지원한다."
    },
    {
        "goal":  "인지기능 강화 및 스트레스 해소",
        "detail":  "효돌이AI돌봄인형을 지원한다."
    },
    {
        "goal":  "돌봄로봇지원 이용을 통해 우울감 감소",
        "detail":  "돌봄로봇관련 정보제공"
    },
    {
        "goal":  "건강 상태 파악 및 인지 기능 유지",
        "detail":  "제공된 인지키트를 수행하도록 격려한다."
    },
    {
        "goal":  "기억력 저하 예방, 기억력 저하로 인한 일상생활의 어려움과 불편함 감소",
        "detail":  "가정방문을 통해 가정내 할 수 있는 인지훈련을 받을 수 있도록 함, 물건에 이름표 부착함"
    },
    {
        "goal":  "인지활동 월 2회 이상 수행",
        "detail":  "인지활동지를 제공한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "인지강화 교구를 제공한다."
    },
    {
        "goal":  "기억력 및 지남력의 현재 상태 유지",
        "detail":  "인지강화책 및 색칠자료를 제공한다."
    },
    {
        "goal":  "지남력 유지",
        "detail":  "인지향상을 위해 학습 도구를 지원한다."
    },
    {
        "goal":  "인지기능 저하 예방 및 현 지남력 유지",
        "detail":  "색칠하기, 뇌를 깨우자 등 인지강화 활동책을 제공한다."
    },
    {
        "goal":  "인지기능 유지 및 향상",
        "detail":  "인지키트 제공한다."
    },
    {
        "goal":  "건강 상태를 알고, 인지 기능 유지",
        "detail":  "인지개선을 위한 인지키트 제공한다."
    },
    {
        "goal":  "인지기능 훈련을 통한 잔존능력 개발 및 유지",
        "detail":  "인지기능악화 예방 활동(퍼즐, 색칠북) 교육을 제공한다."
    },
    {
        "goal":  "방문형 인지 키트를 활여하여 대상자 인지기능 향상",
        "detail":  "방문형 키트 제공 및 실사용 체크를 통한 행동 변화 관찰한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "기능수준에 적합한 인지물품 제공한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "인지활동북 제공 및 활용 점검한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "전산인지 프로그램 제공한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "만다라, 꽃그림, 퍼즐 등 인지재활 학습지 및 도구 제공한다."
    },
    {
        "goal":  "인지기능 저하 예방",
        "detail":  "인지 학습 꾸러미 제공한다."
    },
    {
        "goal":  "기억력 저하로 인한 일상생활의 어려움과 불편감 감소",
        "detail":  "일대일방문형 인지프로그램을 통해 가정내에서 할수 있는 인지훈련을 제공한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "색칠형 만다라, 퍼즐맞추기 제공한다."
    },
    {
        "goal":  "인지기능 유지 및 향상",
        "detail":  "방문형 인지관리키트 제공한다."
    },
    {
        "goal":  "정신적 부담 경감",
        "detail":  "가족교실 및 자조모임 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "치매약물 조기복용",
        "detail":  "보호자 상담을 통해 치매약물의 조기 복용 필요성을 안내한다."
    },
    {
        "goal":  "일상생활 복귀",
        "detail":  "식사 혼자 떠먹기 할수 있도록 교육 한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "인지기능이 도움되는 일상생활 교육을 실시한다. (책 소리내서 읽기, 달력보기, 뉴스 따라 읽기)"
    },
    {
        "goal":  "치매질환 관리",
        "detail":  "치매질환 전반에 대한 교육을 제공 한다."
    },
    {
        "goal":  "치매질환 관리",
        "detail":  "인지활동 필요성 설명드리고 활동물품 제공하여 활용법 안내한다."
    },
    {
        "goal":  "치매질환 관리",
        "detail":  "진료 및 약물복용 중요성 교육한다."
    },
    {
        "goal":  "가정에서 치매환자 간호에 접목",
        "detail":  "센터 내 헤아림 가족교실을 제공한다."
    },
    {
        "goal":  "보호자 상담 교육 제공을 통한 대상자 돌봄기능 향상",
        "detail":  "월 ()회 보호자 상담 교육을 제공한다."
    },
    {
        "goal":  "주조호자와 적절한 관계를 형성하고 부담 경감",
        "detail":  "치매에 대한 정보를 제공한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "치매 질병에 대한 기본교육 제공한다."
    },
    {
        "goal":  "치매환자 돌봄에 대한 이해와 심리적 부담 경감",
        "detail":  "가족교실, 자조모임 제공한다."
    },
    {
        "goal":  "치매환자 돌봄에 대한 이해와 심리적 부담 경감",
        "detail":  "치매상담콜센터 자조모임 전담 상담사를 연결한다."
    },
    {
        "goal":  "치매환자에 대한 이해력 향상",
        "detail":  "치매환자 케어 및 정신행동증상 대처법 교육을 제공한다."
    },
    {
        "goal":  "치매 대처 능력을 향상",
        "detail":  "치매와 정신행동 증상 대처 기술 교육을 제공한다."
    },
    {
        "goal":  "인지기능 저하로 인한 사고 예방",
        "detail":  "인지활동의 중요성 교육 및 인지꾸러미 활용 교육을 제공한다."
    },
    {
        "goal":  "보호자끼리 서로 굥유로 스트레스 해소",
        "detail":  "가족프로그램 제공한다."
    },
    {
        "goal":  "돌봄대처능력향상",
        "detail":  "치매가이드북 제공하고, 치매어르신 돌봄기술을 정기적으로 교육한다."
    },
    {
        "goal":  "치매환자에 대한 보호자의 인식 개선",
        "detail":  "인식개선 교육을 제공한다."
    },
    {
        "goal":  "보호자상담 교육을 통하여 부양부담 완화",
        "detail":  "보호자상담 제공한다.(월1회)"
    },
    {
        "goal":  "사회활동 유지 및 증진",
        "detail":  "쉼터를 이용한 활동 참여를 격려한다."
    },
    {
        "goal":  "기억력 저하 예방",
        "detail":  "쉼터 이용 독려한다."
    },
    {
        "goal":  "사회적 접촉과 교류의 기회를 가진다.",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "또래 모임 활동으로 사회성 유지",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "프로그램 활동을 통한 잔존기능 유지",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "프로그램 활동을 통해 우울 및 스트레스를 해소",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "인지기능 향상 / 인지기능 훈련을 통한 잔존능력 개발 및 유지",
        "detail":  "쉼터 프로그램 참여을 통한 인지기능 유지 및 향상을 위한 교육 프로그램 참여를 독려한다."
    },
    {
        "goal":  "쉼터 프로그램 참여로 대상자의 일상생활 기능향상",
        "detail":  "쉼터 프로그램 제공 및 참여 빈도를 확인한다."
    },
    {
        "goal":  "사회적 접촉과 교류의 기회를 가진다",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "사회적 접촉 및 교류 증진",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "정신행동증상의 빈도와 정도 완화",
        "detail":  "환경적 자극을 충족하는 쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "인지기능 유지",
        "detail":  "심리치료, 인지활동, 인지학습등 쉼터 프로그램 제공한다. (주2회)"
    },
    {
        "goal":  "사회성 향상",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "기억력 저하 예방",
        "detail":  "치매안심센터 내 인지재활 프로그램에 참여 유도하여 기억력 훈련을 제공한다."
    },
    {
        "goal":  "외출을 통하여 기분 전환의 기회를 가진다",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "쉼터 프로그램에 참여하여 인지기능 향상",
        "detail":  "쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "인지기능 향상 / 인지기능 훈련을 통한 잔존능력 개발 및 유지",
        "detail":  "인지기능악화 예방 활동(퍼즐, 색칠북) 교육을 제공한다."
    },
    {
        "goal":  "협약 병원 연결을 통해 대상자 신체 기능 향상",
        "detail":  "협약병원 연결 및 병원 연결 확인한다."
    },
    {
        "goal":  "치매치료를 위한 정기적 외래방문",
        "detail":  "정기적인 협약병원 진료 확인한다."
    },
    {
        "goal":  "치매증상 및 정신행동증상 완화",
        "detail":  "약을 처방 받아 복약할 수 있도록 지원한다."
    },
    {
        "goal":  "적절한 치매치료",
        "detail":  "협약병원 연결 및 정기적인 병원 진료 필요성 교육한다."
    },
    {
        "goal":  "병원(진료실) 스스로 방문",
        "detail":  "GPS스마트지킴이제공, 병원(내부) 약 제공한다."
    },
    {
        "goal":  "관내 정신과 및 신경과 주기적 방문",
        "detail":  "관내 정신과 및 신경과 정보를 제공한다."
    },
    {
        "goal":  "인지기능 수준 유지",
        "detail":  "대상자 및 보호자에게 치매 주간보호센터 정보를 제공한다."
    },
    {
        "goal":  "상황에 맞는 적절한 돌봄서비스 이용",
        "detail":  "가능한 돌봄서비스 확인 및 이용 격려한다."
    },
    {
        "goal":  "안정적인 노후생활",
        "detail":  "노인맞춤형돌봄서비스를 신청한다."
    },
    {
        "goal":  "일상 생활 사고를 예방",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "독거사 예방",
        "detail":  "복지정책 및 생활지원사 연결 제공한다."
    },
    {
        "goal":  "적절한 투약관리 기능 및 정서적 고립감완화",
        "detail":  "노인맞춤돌봄서비스를 연계한다."
    },
    {
        "goal":  "인지기능 향상",
        "detail":  "노인맞춤돌봄서비스를 연계한다."
    },
    {
        "goal":  "인지기능 향상 및 심리적 안정감",
        "detail":  "노인돌봄맞춤돌봄서비스 정보 제공 및 연계한다."
    },
    {
        "goal":  "노인의료돌봄통합지원으로 인지기능 향상",
        "detail":  "노인의료돌봄통합지원시범사업을 연계한다."
    },
    {
        "goal":  "병원에 대한 거부감 감소",
        "detail":  "노인의료돌봄통합지원시범사업 정보를 제공한다."
    },
    {
        "goal":  "치매 및 동반질환 관리",
        "detail":  "전문의 상담 안내한다."
    },
    {
        "goal":  "동반질환 관리",
        "detail":  "동반질환 관리를 위한 정기적인 병의원 진료 여부 점검한다."
    },
    {
        "goal":  "인지기능 유지 및 현 질병상태의 악화방지",
        "detail":  "대상자 처방받는 병원 외래에서 치매약을 처방받을수 있도록한다."
    },
    {
        "goal":  "스스로 투약관리를 하여 인지기능 유지",
        "detail":  "약달력 제공 및 교육한다."
    },
    {
        "goal":  "대상자의 증상에 맞는 병의원을 이용",
        "detail":  "지역 내 병의원 정보 제공한다."
    },
    {
        "goal":  "일상생활의 편의성 향상",
        "detail":  "필요한 복지용구 안내 및 신청한다."
    },
    {
        "goal":  "인지기능 저하로 인한 사고 예방",
        "detail":  "낙상 및 안전사고 예방을 위한 장기요양보험 복지용구 연계한다."
    },
    {
        "goal":  "저렴하고 다양한 기구 이용",
        "detail":  "복지용구 센터 연결 제공한다."
    },
    {
        "goal":  "대상자 일상생활의 질 향상",
        "detail":  "복지용구 구입 및 대여에 관한 정보를 제공하고 건강보험 공단에 연계한다."
    },
    {
        "goal":  "복지용구를 제공하여 조호부담 경감",
        "detail":  "복지용구 안내 및 연계한다."
    },
    {
        "goal":  "주기적인 운동",
        "detail":  "복지용구 대여 방법에 대한 안내한다."
    },
    {
        "goal":  "일상생활 유지",
        "detail":  "장기요양등급 신청 정보를 안내한다."
    },
    {
        "goal":  "일상생활의 도움",
        "detail":  "등급 및 장기요양서비스 신청한다."
    },
    {
        "goal":  "인지기능을 유지",
        "detail":  "돌봄제공자의 도움을 받아 매일 달력보고 날짜 확인 하기 서비스를 제공한다."
    },
    {
        "goal":  "인지기능 강화",
        "detail":  "주간보호센터 이용 연계한다."
    },
    {
        "goal":  "일상생활지원으로 치매 정도 유지",
        "detail":  "건강보험공단 및 장기요양서비스기관 연계 제공한다."
    },
    {
        "goal":  "인지기능 유지 및 향상",
        "detail":  "장기요양서비스 수급을 위해 장기요양인정 신청한다."
    },
    {
        "goal":  "요양보호사와 지속적인 접촉으로 인지기능을 유지",
        "detail":  "장기요양서비스 연계한다."
    },
    {
        "goal":  "요양보호사 서비스를 받아 균형잡힌 식사",
        "detail":  "장기요양서비스 관련 정보 제공한다."
    },
    {
        "goal":  "대상자 일상생활 기능 향상",
        "detail":  "프로그램 연결 및 안내한다."
    },
    {
        "goal":  "사회적 접촉과 교류의 기회 마련",
        "detail":  "지역사회기관 프로그램 참여 연계한다."
    },
    {
        "goal":  "사회활동을 유지",
        "detail":  "이용 가능한 경로당, 노인복지관 프로그램 확인하고 정보제공한다."
    },
    {
        "goal":  "외출기능향상과 기억력저하로 인한 일상생활의 불편감감소",
        "detail":  "홍북읍 주민자치센터에서 시행하는 프로그램에 연계한다."
    },
    {
        "goal":  "사회적 접촉과 교류의 기회를 가진다",
        "detail":  "지역사회기관 프로그램 연계한다."
    },
    {
        "goal":  "욕구에 맞게 프로그램에 참여",
        "detail":  "기관 별 프로그램 정보 제공한다."
    },
    {
        "goal":  "꾸준한 치매치료로 삻의 질 향상",
        "detail":  "치매관리주치의 연계한다."
    },
    {
        "goal":  "치매관리주치의를 통하여 인지기능을 향상",
        "detail":  "치매관리주치의 연계한다."
    },
    {
        "goal":  "치매 증상에 맞게 진료",
        "detail":  "치매관리주치의 정보 제공한다."
    },
    {
        "goal":  "인지기능 저하로 인한 사고예방",
        "detail":  "치매안심병원 서비스 연계한다."
    },
    {
        "goal":  "자/타인의 위험에서 안전",
        "detail":  "치매안심병원 입원 안내한다."
    },
    {
        "goal":  "정신적 기능 향상",
        "detail":  "퇴소후 사례관리 제공한다."
    },
    {
        "goal":  "프로그램에 참여하여 인지기능 향상",
        "detail":  "치매안심병동 연계한다."
    },
    {
        "goal":  "병원입원에 대한 거부감을 감소",
        "detail":  "치매안심병동 관련 정보 제공한다."
    },
    {
        "goal":  "가족 응집력/협력 강화",
        "detail":  "가족교실 및 자조모임 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "가족의 심리적인 부담감 감소",
        "detail":  "가족 힐링프로그램 참여도록 안내한다."
    },
    {
        "goal":  "정신행동증상 관련 지식향상",
        "detail":  "정신행동증상 기본교육 제공한다."
    },
    {
        "goal":  "정신행동증상을 빠르게 대처",
        "detail":  "가족지원프로그램 지원한다."
    },
    {
        "goal":  "치매환자에 대한 이해를 높이고, 지지적인 역할",
        "detail":  "가족교실 및 자조모임 정보제공 및 참여 격려한다."
    },
    {
        "goal":  "심리적 안정감",
        "detail":  "돌봄제공자의 정서적 지지를 위한 자조 모임 연계한다."
    },
    {
        "goal":  "가족 상호간의 마음을 알고 이해",
        "detail":  "가족지원프로그램 제공연계한다."
    },
    {
        "goal":  "우울의 증상을 완화",
        "detail":  "신체활동을 강화한다."
    },
    {
        "goal":  "기억력 수준 유지 및 악화 예방",
        "detail":  "치매약을 정확하게 복용하도록 설명하고 확인한다"
    },
    {
        "goal":  "요실금, 변실금 등으로 위축된 사회활동을 격려하고 이웃과의 교류를 통해 우울감 해소",
        "detail":  "요실금 예방체조 및 생활습관을 교육한다."
    },
    {
        "goal":  "요실금, 변실금 등으로 위축된 사회활동을 격려하고 이웃과의 교류를 통해 우울감 해소",
        "detail":  "경로당 등 사회활동을 격려한다."
    },
    {
        "goal":  "정서적 지지로 대상자의 우울감을 경감",
        "detail":  "보호자와의 교류 시간을 늘리도록 격려한다."
    },
    {
        "goal":  "정서적 지지로 대상자의 우울감 경감",
        "detail":  "함께 어울릴 수 있는 마을 지인과의 접촉 기회 늘리도록 격려한다."
    },
    {
        "goal":  "정서적 지지로 대상자의 우울감 경감",
        "detail":  "방문 시 말벗 서비스로 정서적 지지 제공한다."
    },
    {
        "goal":  "정신질환증상을 완화",
        "detail":  "정신질환관련하여 의사 상담 권유한다."
    },
    {
        "goal":  "우울증상의 빈도와 정도 완화",
        "detail":  "우울정도와 자살위험도 평가 및 서비스 연계를 위하여 정신건강복지센터에 의뢰한다."
    },
    {
        "goal":  "정기적으로 외래 진료",
        "detail":  "우울증상 완화를 위해 정기 진료를 독려한다."
    },
    {
        "goal":  "정신행동증상의 빈도 완화",
        "detail":  "정기적으로 방문하여 행동증상에 대해 적절한 상담을 제공한다."
    },
    {
        "goal":  "정신행동 증상관련 확인을 통해 환자의 삶의 질 향상",
        "detail":  "정신행동 증상 빈도 체크한다."
    },
    {
        "goal":  "정신행동증상에 대한 대처능력 향상",
        "detail":  "치매지원 서비스 연계한다."
    },
    {
        "goal":  "정신행동증상에 대한 대처능력 향상",
        "detail":  "치매환자의 돌봄 사각지대를 해소 심리적요구와 관련된 문제에 개입한다."
    },
    {
        "goal":  "정신행동증상에 대한 대처능력 향상",
        "detail":  "정신행동증상에 대한 정보를 제공하고 빠른 대처법을 교육한다"
    },
    {
        "goal":  "정서적 안정감 유지",
        "detail":  "주기적인 전화 및 방문을 통한 안부확인, 말벗, 정서적 지지위한 상담 제공한다."
    },
    {
        "goal":  "정신행동증상에 대한 대처능력 향상",
        "detail":  "정신행동증상 대처 관련 교육 제공한다."
    },
    {
        "goal":  "정신행동증상 조절",
        "detail":  "증상 관찰 및 적절한 약물투여 교육한다."
    },
    {
        "goal":  "정신행동증상에 주기적인 상담 제공",
        "detail":  "정신행동증상 관련 개별상담 제공한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "필요 서류 구비 해서 보호자와 보건소 방문 교육한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회감지기를 제공한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회인식표 제공 및 배회감지기 제공 및 배회, 실종 예방 교육을 제공한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회감지기 지원사업을 안내한다"
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "배회감지기 제공한다."
    },
    {
        "goal":  "실종 후 발견 시 신속하게 가정으로 복귀",
        "detail":  "배회감지기 보급, 월 통신비 지원한다."
    },
    {
        "goal":  "실종시 빠르게 대처",
        "detail":  "배회감지기 지원한다."
    },
    {
        "goal":  "실종사고를 예방",
        "detail":  "배회감지기 제공한다."
    },
    {
        "goal":  "배회로 인한 사고 발생 위험성 감소 및 예방",
        "detail":  "배회증상이 있는 대상자에게 GPS지원하고 서비스 안내한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회감지기 제공한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "배회감지기 정보 제공 및 연계한다."
    },
    {
        "goal":  "배회인식표 등록",
        "detail":  "필요 서류 구비 해서 보호자와 보건소 방문 교육한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회인식표를 제공한다."
    },
    {
        "goal":  "사고발생예방",
        "detail":  "인식표 지급한다."
    },
    {
        "goal":  "활동 및 안전성 확보",
        "detail":  "배회가능성 대상자에게 배회인식표를 발급한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회익식표를 제공한다"
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "배회가능 인식표 발급한다."
    },
    {
        "goal":  "실종 후 발견 시 신속하게 가정으로 복귀",
        "detail":  "인식표 및 보호자용 실종대응카드 제공한다."
    },
    {
        "goal":  "실종시 빠르게 대처",
        "detail":  "배회인식표 지원한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회인식표 제공한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고 발생 감소 및 예방",
        "detail":  "배회가능 어르신 인식표를 제공한다."
    },
    {
        "goal":  "배회로 인한 사고 발생 위험성 감소 및 예방",
        "detail":  "치매안심센터에서 배회가능 어르신 인식표를 발급한다."
    },
    {
        "goal":  "돌봄시 정신적 부담감 경감",
        "detail":  "배회인식표 제공한다."
    },
    {
        "goal":  "대상자의 실종을 예방",
        "detail":  "배회인식표 사업 정보 안내한다."
    },
    {
        "goal":  "주보호자 돌봄 대처능력 향상",
        "detail":  "치매와 정신행동증상 대처 기술 교육한다."
    },
    {
        "goal":  "보호자가 정신행동 증상을 이해",
        "detail":  "돌봄제공자에 대한 심리적 지지를 제공한다."
    },
    {
        "goal":  "보호자가 정신행동 증상을 이해",
        "detail":  "심한 경우 전문의와 상담하도록 안내한다."
    },
    {
        "goal":  "보호자가 정신행동 증상을 이해",
        "detail":  "주의 전환하는 방법을 제공한다.(적절한 환경, 단순한일거리제공)"
    },
    {
        "goal":  "외부 활동 참여로 우울 질환을 관리",
        "detail":  "주간보호센터 참여 모니터링한다."
    },
    {
        "goal":  "외부 활동 참여로 우울 질환을 관리",
        "detail":  "우울 질환 관리를 위한 정보 제공한다."
    },
    {
        "goal":  "외부 활동 참여로 우울 질환을 관리",
        "detail":  "가족교육으로 지지 체제구축 및 정서적 지지 독려한다."
    },
    {
        "goal":  "주조호자와 적절한 관계를 형성하고 부담을 경감",
        "detail":  "정신행동증상 대처방법을 교육한다."
    },
    {
        "goal":  "주조호자와 적절한 관계를 형성하고 부담을 경감",
        "detail":  "정신행동증상 조절 위한 약물처방 여부 확인 및 병원진료를 안내한다."
    },
    {
        "goal":  "정신행동증상에 대한 대처능력 향상",
        "detail":  "가족교실 참여 권유한다."
    },
    {
        "goal":  "정신행동증상을 빠르게 대처",
        "detail":  "보호자교육 지원한다."
    },
    {
        "goal":  "정신행동 증상을 대처",
        "detail":  "치매로 인한 정신행동 증상에 대한 기본 지식 및 대처 기술 교육한다."
    },
    {
        "goal":  "돌봄제공자의 안정과 지지 강화",
        "detail":  "증상별 관리 및 질환에 대한 정보제공 , 대처 방안 교육을 제공한다."
    },
    {
        "goal":  "배회로 인한 사고 및 대처능력 향상",
        "detail":  "치매체크앱과 GPS등으로 대상자 길 잃음 발생시 신속하게 찾을 수 있는 방안을 보호자에게 교육한다."
    },
    {
        "goal":  "치매환자의 정신행동증상을 이해",
        "detail":  "치매인식개선 교육한다."
    },
    {
        "goal":  "주보호자의 우울감 감소",
        "detail":  "지역 내 가족교육 관련 정보를 제공한다."
    },
    {
        "goal":  "사회적 고립감 감소",
        "detail":  "전화 및 방문을 통한 안부 확인 및 비상연락망 준비한다."
    },
    {
        "goal":  "정서적 안정감을 통한 생활의욕 향상",
        "detail":  "전화 및 방문을 통한 안부 확인 및 비상연락망 준비한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "치매안심병원 서비스 연계한다."
    },
    {
        "goal":  "치매환자의 돌봄 사각지대 해소",
        "detail":  "지역의료기관에 연계 의뢰한다."
    },
    {
        "goal":  "전문의 상담을 통해 정신행동증상완화",
        "detail":  "협약병원연결한다."
    },
    {
        "goal":  "정신행동증상을 조절",
        "detail":  "정신행동증상 관찰한다."
    },
    {
        "goal":  "정신행동증상에 관한 주기적인 진료",
        "detail":  "협약병원 정보 제공한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "정신행동 치료 지원한다."
    },
    {
        "goal":  "상담 및 약처방",
        "detail":  "병의원서비스 연계한다."
    },
    {
        "goal":  "병의원서비스로 정신행동 증상 조절",
        "detail":  "병의원서비스 연계한다."
    },
    {
        "goal":  "수면장애 완화",
        "detail":  "관내 정신과 및 신경과 정보를 제공한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "정서적 안정지원한다."
    },
    {
        "goal":  "정신행동 질환 대처법등을 공유",
        "detail":  "외부기관가족프로그램연계한다."
    },
    {
        "goal":  "치매환자에 대한 이해도 향상 및 지지",
        "detail":  "가정통합상담센터 연계한다."
    },
    {
        "goal":  "가족에게 심리적 안정을 제공",
        "detail":  "외부기관가족프로그램 연계한다."
    },
    {
        "goal":  "우울감 감소",
        "detail":  "가족프로그램 정보 제공한다."
    },
    {
        "goal":  "장기요양서비스 연계",
        "detail":  "외출시 동행, 병원 동행, 산책 동행 등을 지원한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "상황에 맞는 적절한 서비스 이용 연계한다."
    },
    {
        "goal":  "약복용 및 신속히 대처",
        "detail":  "장기요양서비스연계한다."
    },
    {
        "goal":  "우울감 완화",
        "detail":  "방문요양 장기요양기관 연계 및 방문요양서비스 이용 격려한다."
    },
    {
        "goal":  "지속적인 관찰과 복약사항 확인",
        "detail":  "장기요양서비스 연계한다."
    },
    {
        "goal":  "정신행동증상 완화",
        "detail":  "요양보호사 관련 서비스 안내한다."
    },
    {
        "goal":  "정신행동증상에 대한 대처능력 향상",
        "detail":  "정신건강복지센터에 연계한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "정신건강복지센터 서비스 연계한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고 발생 감소 및 예방",
        "detail":  "경찰서, 정신건강증진센터 등 연계한다."
    },
    {
        "goal":  "지역사회기관서비스로 정신행동증상 조절",
        "detail":  "지역사회기관서비스 연계한다."
    },
    {
        "goal":  "대상자의 배회증상 완화",
        "detail":  "사전지문등록 실시한다."
    },
    {
        "goal":  "적절한 상담 및 약처방",
        "detail":  "치매관리주치의 연계한다."
    },
    {
        "goal":  "정신행동증상 조절",
        "detail":  "치매관리주치의 연계한다."
    },
    {
        "goal":  "우울감 감소",
        "detail":  "치매관리주치의 정보 제공한다."
    },
    {
        "goal":  "증상행동 증상 완화",
        "detail":  "입원치료 연계 및 상담 연계한다."
    },
    {
        "goal":  "정신행동증상 조절",
        "detail":  "치매안심병동 연계한다."
    },
    {
        "goal":  "대상자의 환각 증상 완화",
        "detail":  "치매안심병동 관련 정보 제공한다."
    },
    {
        "goal":  "정신행동증상으로 인한 사고예방",
        "detail":  "치매안심병원서비스 연계한다."
    },
    {
        "goal":  "적절한 상담 및 약처방",
        "detail":  "치매안심병원서비스 연계한다."
    },
    {
        "goal":  "치매안심병원서비스로 정신행동증상 조절",
        "detail":  "치매안심병원서비스 연계한다."
    },
    {
        "goal":  "스스로 투약관리",
        "detail":  "치매안심병원서비스 안내한다."
    },
    {
        "goal":  "규칙적인 투약교육 및 투약관리",
        "detail":  "대상자의 투약관리를 위해 보호자 교육을 실시한다."
    },
    {
        "goal":  "제공된 약달력을 활용하여 스스로 투약관리",
        "detail":  "투약 상황을 확인하고 투약의 중요성을 지속적으로 교육한다."
    },
    {
        "goal":  "진료 및 약 복용의 중요성 인지",
        "detail":  "정기적인 병원진료 및 약 처방, 복용방법을 교육한다."
    },
    {
        "goal":  "정확한 투약활동을 유지",
        "detail":  "약달력 제공 및 교육한다."
    },
    {
        "goal":  "투약 순응도 향상",
        "detail":  "치매약물 투약여주 확인 및 점검 제공한다."
    },
    {
        "goal":  "현재 복용 중인 약물에 대한 정보 인지",
        "detail":  "복용중인 약물을 파악하고 정보를 제공한다."
    },
    {
        "goal":  "현재 복용 중인 약물에 대한 정보 인지",
        "detail":  "복용중인 약물에 대한 정리 방법을 제공한다."
    },
    {
        "goal":  "투약시간에 맞추어 약을 복용",
        "detail":  "약달력 제공 및 사용법을 교육한다."
    },
    {
        "goal":  "약달력을 제공하여 스스로 투약관리",
        "detail":  "약달력을 제공한다."
    },
    {
        "goal":  "약을 스스로 복용",
        "detail":  "약먹는 시간을 돌봄로봇에 입력하여 매일 알려준다."
    },
    {
        "goal":  "건강한 삶의 질 유지",
        "detail":  "월 또는 주단위 투약현황 및 투약 빈도 체크한다."
    },
    {
        "goal":  "올바른 약물관리 능력 개선",
        "detail":  "약 복용시간 알람 설정한다."
    },
    {
        "goal":  "정해진 시간에 투약",
        "detail":  "돌봄로봇지원연계한다."
    },
    {
        "goal":  "적절한 투약관리 기능 향상",
        "detail":  "복용중인 약물 확인하여 로봇기능에 투약시간 알림설정 통해 투약안내 받도록 안내한다."
    },
    {
        "goal":  "스스로 약을 복용",
        "detail":  "돌봄로봇이 투약시간 안내한다."
    },
    {
        "goal":  "병의원 처방에 맞는 투약관리",
        "detail":  "돌봄로봇 관련 정보를 제공한다."
    },
    {
        "goal":  "약물복용 관련 불편감 최소화",
        "detail":  "배우자 도움으로 치매약 꾸준히 복용함, 약달력 제공한다."
    },
    {
        "goal":  "적절한 투약관리를 통해 합병증을 예방",
        "detail":  "규칙적으로 약 복용을 할 수 있도록 지도한다."
    },
    {
        "goal":  "약물에 대한 정보 인지",
        "detail":  "현재 복용중인 약물에 대한 정보 제공을 하고, 대상자가 스스로 약을 구분할 수 있도록 약 정리를 실시한다."
    },
    {
        "goal":  "치매약물 및 동반질환 약물을 규칙적으로 복용",
        "detail":  "병원 진료 여부 및 투약 확인을 한다. 필요시 약달력 제공한다."
    },
    {
        "goal":  "치매약물 및 동반질환 약물을 규칙적으로 복용",
        "detail":  "규칙적으로 약 복용을 할 수 있도록 독려한다."
    },
    {
        "goal":  "약달력을 이용하여 규칙적으로 약을 복용",
        "detail":  "규칙적인 투약관리를 위해 약달력을 제공한다."
    },
    {
        "goal":  "잊지않고 제 때 복용",
        "detail":  "투약 달력 제공한다."
    },
    {
        "goal":  "올바르게 약물관리",
        "detail":  "치매약물 복용의 중요성 교육한다."
    },
    {
        "goal":  "스스로 투약관리",
        "detail":  "약달력 제공 및 투약방법을 교육한다."
    },
    {
        "goal":  "치매 질환 관리",
        "detail":  "치매 질환에 대한 전반적인 교육한다."
    },
    {
        "goal":  "치매 질환 관리",
        "detail":  "정기적인 병원 진료와 약물 복용 모니터링한다."
    },
    {
        "goal":  "치매 질환 관리",
        "detail":  "치매 약물 복용의 중요성 설명 및 관리한다."
    },
    {
        "goal":  "치매 질환 관리",
        "detail":  "치매 약물 복용의 중요성에 대하여 설명한다."
    },
    {
        "goal":  "치매 질환 관리",
        "detail":  "약물 복용 관리를 위하여 약달력 제공 및 치매 치료비 지원한다."
    },
    {
        "goal":  "치매 질환 관리",
        "detail":  "치매 질환에 대한 전반적 인 정보 제공한다."
    },
    {
        "goal":  "치매 질환 관리",
        "detail":  "치매에 대한 교육한다."
    },
    {
        "goal":  "치매 및 정신 질환 관리",
        "detail":  "인지 강화 교육 자료 제공 및 치매 치료비 지원한다."
    },
    {
        "goal":  "정확한 복약으로 정신행동 증상 등 치매증상 완화",
        "detail":  "정확한 복약을 위한 교육을 시행한다."
    },
    {
        "goal":  "투약관리를 통해 대상자의 건강한 삶의 질 유지",
        "detail":  "월. 또는 주 단위 투약현황 및 투약 빈도 체크한다."
    },
    {
        "goal":  "약물 복용의 중요성을 인지",
        "detail":  "약 복용 유무를 점검한다."
    },
    {
        "goal":  "주기적인 외래진료 및 약 복용 확인",
        "detail":  "약달력 제공 및 교육한다."
    },
    {
        "goal":  "복용중인 약물을 관리",
        "detail":  "현재 복용중인 치매약, 동반질환 치료 약물에 대한 정보 제공과 복약지도한다."
    },
    {
        "goal":  "복약지도를 통한 증상관리 완화",
        "detail":  "치매약물관리 교육 및 동반중인 치매약물에 대한 정보제공한다."
    },
    {
        "goal":  "적절한 투약 관리를 통한 합병증 예방",
        "detail":  "수첩을 만들어 복용 체크후 모니터링 한다."
    },
    {
        "goal":  "스스로 약을 복용",
        "detail":  "복약사항 확인 및 복약지도한다."
    },
    {
        "goal":  "투약관리 관련 욕구에 맞춰 서비스 제공",
        "detail":  "기관 별 프로그램 정보 제공한다."
    },
    {
        "goal":  "올바른 약물관리 능력 개선",
        "detail":  "치매약물 투약여부 확인 및 점검한다."
    },
    {
        "goal":  "적절한 투약 관리",
        "detail":  "병원 동행한다."
    },
    {
        "goal":  "의사의 지시대로 약을 복용",
        "detail":  "가까운 지역사회자원 연계하여 약물 복용여부를 확인한다."
    },
    {
        "goal":  "스스로 약 관리와 복용",
        "detail":  "복약 사항 체크한다."
    },
    {
        "goal":  "병의원 처방에 맞는 투약관리를 실시",
        "detail":  "지역 내 봉사자 및 봉사단체 연계한다."
    },
    {
        "goal":  "경제적 부담 경감",
        "detail":  "치매 치료비 지원, 조호물품 제공한다."
    },
    {
        "goal":  "주기적인 건강관리를 통해 안정적으로 약을 복용",
        "detail":  "보호자에게 병원 진료 여부 및 투약 확인을 한다."
    },
    {
        "goal":  "꾸준하게 치매약 복용",
        "detail":  "매달 치매약값지원 확인 및 주보호자를 통한 치매약 복용 모니터링을 한다."
    },
    {
        "goal":  "약값에 대한 부담 감소",
        "detail":  "치료진료 및 치료비지원에 대해 설명, 지원한다."
    },
    {
        "goal":  "치매치료관리비 지원",
        "detail":  "치매치료관리비 지원을 통해 약을 규칙적으로 복용할수 있다."
    },
    {
        "goal":  "주기적인 건강관리를 통해 안정적으로 약을 복용",
        "detail":  "치매치료관리비를 신청한다."
    },
    {
        "goal":  "지원체계 이용을 통한 경제적 부담완화",
        "detail":  "치매지원 서비스에 대한 안내 및 연계한다."
    },
    {
        "goal":  "지속적으로 치료·관리함으로써 증상 호전 및 가정의 경제적 부담을 경감",
        "detail":  "치매치료관리비 보험급여분 중 본인부담금 지원한다."
    },
    {
        "goal":  "경제적인 도움",
        "detail":  "치매치료관리비 신청한다."
    },
    {
        "goal":  "경제적 부담을 완화",
        "detail":  "치매치료관리비 지원한다."
    },
    {
        "goal":  "투약관리 유지",
        "detail":  "치매치료관리비 지원한다."
    },
    {
        "goal":  "치매 치료를 위한 정기적 외래방문",
        "detail":  "현재 복용중인 약물에 대한 정보를 제공한다."
    },
    {
        "goal":  "경제적 부담 경감",
        "detail":  "치매 치료비 지원 및 조호물품 제공한다."
    },
    {
        "goal":  "적절한 의료비 확보 및 투약유지",
        "detail":  "치매치료관리비를 지원받을수 있도록 신청한다."
    },
    {
        "goal":  "지속적으로 약물 복용",
        "detail":  "투약비 지원한다."
    },
    {
        "goal":  "인지기능 증진",
        "detail":  "치매치료관리비 지원한다."
    },
    {
        "goal":  "대상자의 경제적 부담를 완화",
        "detail":  "치매치료관리비 사업 안내한다."
    },
    {
        "goal":  "올바른 약물관리 능력 개선",
        "detail":  "원격진료 서비스 연계 및 건강관리 상담한다."
    },
    {
        "goal":  "약처방 도움",
        "detail":  "본인외에도 처방 가능하도록 한다."
    },
    {
        "goal":  "진료유지를 통한 증상완화 관리",
        "detail":  "동반질환 치료 연계 및 치매약 복용 관리 상담 제공한다."
    },
    {
        "goal":  "현 질병의 악화방지 및 합병증발생 예방",
        "detail":  "협약병원인 홍성의료원 신경과에 외래진료일 확인하여 규칙적인 외래진료 및 투약이 이행되도록 전화확인한다."
    },
    {
        "goal":  "정해진 날짜에 병원진료",
        "detail":  "병원측에서 진료일 안내한다."
    },
    {
        "goal":  "치매증상에 맞게 진료",
        "detail":  "협약병원 관련 정보를 제공 및 연계한다."
    },
    {
        "goal":  "처방에 따라 약 복용",
        "detail":  "약 복용여부를 확인하고 약 복용의 중요성에 대하여 설명한다."
    },
    {
        "goal":  "처방에 따라 약 복용",
        "detail":  "약에 대한 정보제공한다."
    },
    {
        "goal":  "적절한 투약 관리를 통한 합병증 예방",
        "detail":  "적절한 투약 관리 교육을 제공한다."
    },
    {
        "goal":  "만성질환을 잘 관리하여 합병증 예방",
        "detail":  "주기적으로 혈압, 혈당을 측정하고 관찰한다."
    },
    {
        "goal":  "만성질환을 잘 관리하여 합병증 예방",
        "detail":  "정기적인 약물 치료를 하는지 관리한다."
    },
    {
        "goal":  "만성질환을 잘 관리하여 합병증 예방",
        "detail":  "만성질환에 대해 교육하고 관리하도록 독려한다."
    },
    {
        "goal":  "투약관리",
        "detail":  "안부확인 및 규칙적 투약를 위한 독거관리사를 연계한다."
    },
    {
        "goal":  "복용중인 약물 관리",
        "detail":  "생활지원사를 연계한다."
    },
    {
        "goal":  "복용중인 약물 관리",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "올바른 약물관리 능력 개선 및 향상",
        "detail":  "행정복지센터 맞춤형복지팀에 노인돌봄서비스를 연계한다."
    },
    {
        "goal":  "스스로 약 관리 및 약 복용",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "병의원 처방에 맞는 투약관리",
        "detail":  "노인맞춤돌봄서비스 관련 정보 제공한다."
    },
    {
        "goal":  "약복용 도움",
        "detail":  "노인의료돌봄통합지원시범사업을 연계한다."
    },
    {
        "goal":  "스스로 약 관리 및 약 복용",
        "detail":  "노인의료돌봄통합지원시범사업 정보를 제공한다."
    },
    {
        "goal":  "병의원 처방에 맞는 투약관리",
        "detail":  "노인의료돌봄통합지원시범사업 정보를 제공한다."
    },
    {
        "goal":  "올바른 약물관리 능력 개선",
        "detail":  "정기적인 외래진료 확인한다."
    },
    {
        "goal":  "안전한 병의원 방문",
        "detail":  "동행지원서비스연계한다."
    },
    {
        "goal":  "주기적인 병원 방문",
        "detail":  "동행지원서비스 연계한다."
    },
    {
        "goal":  "병의원 처방에 맞는 투약관리",
        "detail":  "요양보호사 동행지원서비스 안내한다."
    },
    {
        "goal":  "올바른 약복용",
        "detail":  "방문건강관리서비스연계한다."
    },
    {
        "goal":  "건강위협요인 파악",
        "detail":  "방문건강팀 의뢰하여 주기적인 건강체크한다."
    },
    {
        "goal":  "약물 오남용 예방",
        "detail":  "방문보건팀 연계한다."
    },
    {
        "goal":  "합병증 발생 및 새로운 질병이환 예방",
        "detail":  "위관영양과 도뇨관교체가 필요한 대상자에게 지역에서 지원 가능한 방문간호기관을 연계한다."
    },
    {
        "goal":  "스스로 약 관리 및 약 복용",
        "detail":  "방문건강관리서비스 연계한다."
    },
    {
        "goal":  "혈압 및 당뇨 수치 관리",
        "detail":  "보건소 내 방문건강관리서비스 안내한다."
    },
    {
        "goal":  "투약 순응도 향상",
        "detail":  "치매약물 투약여부 확인 및 점검한다."
    },
    {
        "goal":  "올바른 약물 복용",
        "detail":  "병의원서비스연계한다."
    },
    {
        "goal":  "예약된 날짜에 병원진료",
        "detail":  "병의원서비스 연계한다."
    },
    {
        "goal":  "지역 내 병의원 이용",
        "detail":  "요양보호사 동행지원서비스 안내한다."
    },
    {
        "goal":  "병의원 방문시 동행지원",
        "detail":  "자원봉사기관연결한다."
    },
    {
        "goal":  "스스로 약 관리 및 약 복용",
        "detail":  "자원봉사기관 연계한다."
    },
    {
        "goal":  "병의원 처방에 맞는 투약관리",
        "detail":  "자원봉사기관을 통한 투약관리 실시한다."
    },
    {
        "goal":  "약복용에 도움",
        "detail":  "지역사회기관연계한다."
    },
    {
        "goal":  "스스로 약 관리 및 약 복용",
        "detail":  "지역사회기관(복지관 등)서비스 연계한다."
    },
    {
        "goal":  "병의원 처방에 맞는 투약관리",
        "detail":  "요양보호사와 주기적인 투약관리 실시한다."
    },
    {
        "goal":  "약복용 도움",
        "detail":  "치매관리주치의 연계한다."
    },
    {
        "goal":  "원격지원",
        "detail":  "치매관리주치의 연계한다."
    },
    {
        "goal":  "스스로 약 관리 및 약 복용",
        "detail":  "치매관리주치의 연계한다."
    },
    {
        "goal":  "대상자의 치매 증상에 맞는 투약관리 실시",
        "detail":  "치매관리주치의 정보 제공한다."
    },
    {
        "goal":  "인지기능 저하로 인한 일상생활 문제 해결",
        "detail":  "일상생활 지원 및 사무관리를 제공한다."
    },
    {
        "goal":  "계획적인 소비를 통해 일상생활을 유지",
        "detail":  "공공후견인제도를 연계한다."
    },
    {
        "goal":  "지원체계 이용을 통한 문제개선",
        "detail":  "법률적 지원 연계한다."
    },
    {
        "goal":  "사회복지 및 의료서비스 지원",
        "detail":  "공공후견인제도지원한다."
    },
    {
        "goal":  "지지체계활용을 통한 법률적 문제 개선",
        "detail":  "공공 후견인제도 연계한다."
    },
    {
        "goal":  "대상자의 의사결정능력을 높인다",
        "detail":  "공공후견인제도 관련 정보 제공한다."
    },
    {
        "goal":  "식사기능향상",
        "detail":  "푸드뱅크 연계한다."
    },
    {
        "goal":  "지원체계 이용을 통한 문제개선",
        "detail":  "치매안심센터 치매환자 지원 연계한다."
    },
    {
        "goal":  "후견대상자를 발굴하여 연계",
        "detail":  "맞춤형사례관리지원한다."
    },
    {
        "goal":  "경제적 부담을 경감",
        "detail":  "조호물품 제공, 장기요양보험 본인부담금 감경제도 정보 제공한다."
    },
    {
        "goal":  "지원체계 이용을 통한 경제적 부담 완화",
        "detail":  "치매치료비 지원한다."
    },
    {
        "goal":  "의사결정능력향상",
        "detail":  "지역 내 사례관리회의 개최한다."
    },
    {
        "goal":  "식료품 및 생활 필수품 접근성 향상",
        "detail":  "먹거리나눔터 신청을 통해 지원 물품을 전달 ,식료품 및 생활 필수품 접근성 향상 할 수 있도록 한다."
    },
    {
        "goal":  "지원체계 이용을 통한 문제개선",
        "detail":  "지역자원을 통한 생필품 지원 연계한다."
    },
    {
        "goal":  "필요한 생필품등을 지원",
        "detail":  "생활용품지원 연계한다."
    },
    {
        "goal":  "조호부담을 경감",
        "detail":  "생활용품 제공한다."
    },
    {
        "goal":  "지원체계 이용을 통한 문제개선",
        "detail":  "재정적 지원 연계한다."
    },
    {
        "goal":  "가정경제에 도움",
        "detail":  "관공서재정지원서비스연계한다."
    },
    {
        "goal":  "경제적 부담 완화",
        "detail":  "의료급여 신청서류 작성보조 연계한다."
    },
    {
        "goal":  "경제적 문제 해결 도움",
        "detail":  "희망복지지원단 연계한다.(생계·주거비지원, 기초연금, 이웃돕기 성금(품)지원, 장애연금)"
    },
    {
        "goal":  "지원체계 이용을 통한 경제적 부담 완화",
        "detail":  "읍면사례관리팀 연계한다."
    },
    {
        "goal":  "대상자의 경제적 부담를 완화한다",
        "detail":  "관공서재정지원 서비스 정보를 제공한다."
    },
    {
        "goal":  "돌봄 경제적 부담 완화",
        "detail":  "지역유관기관한 연계한 물품 제공한다."
    },
    {
        "goal":  "가정경제에 도움",
        "detail":  "생활물품지원연계서비스 연계한다."
    },
    {
        "goal":  "지원체계이용을 통한 경제적 부담 완화",
        "detail":  "지역자원을 통한 물품지원서비스 연계한다."
    },
    {
        "goal":  "지원체계 이용을 통한 생활환경향상",
        "detail":  "홍성사회복지관의 물품지원서비스(생필품지원)에 연계한다."
    },
    {
        "goal":  "대상자의 경제적 부담 완화",
        "detail":  "생활물품지원연계 서비스 관련 정보를 제공한다"
    },
    {
        "goal":  "지원체계 이용을 통한 문제개선",
        "detail":  "경제적 지원 연계한다."
    },
    {
        "goal":  "가정경제에 도움",
        "detail":  "일자리연계연계한다."
    },
    {
        "goal":  "소득창출을 하여 경제적 부담을 경감",
        "detail":  "시니어클럽, 노인종합복지관 노인일자리 사업 연계한다."
    },
    {
        "goal":  "지원체계 이용을 통한 경제적 위기 극복",
        "detail":  "지역사회 일자리 연계한다."
    },
    {
        "goal":  "지원체계 이용을 통한 경제적 위기 극복",
        "detail":  "홍성사회복지관과 노인종합복지관의 노인활동지원사업에 연계한다."
    },
    {
        "goal":  "대상자의 경제적 부담를 완화",
        "detail":  "노인일자리 관련 정보를 제공한다."
    },
    {
        "goal":  "가정경제에 도움",
        "detail":  "지역사회기관재정지원서비스 연계한다."
    },
    {
        "goal":  "지원체계 이용을 통한 경제적 부담 완화",
        "detail":  "장기요양보험제도 서비스 정보제공 연계한다."
    },
    {
        "goal":  "대상자의 경제적 부담를 완화",
        "detail":  "지역사회기관재정지원서비스 정보제공한다."
    },
    {
        "goal":  "안전한 의사결정",
        "detail":  "공공후견인 제도에 대한 정보제공한다."
    },
    {
        "goal":  "법률 문제개선",
        "detail":  "법률적 지원연계한다."
    },
    {
        "goal":  "안전한 의사결정",
        "detail":  "법률서비스를 제공 하여 의사결정 지원 제공한다."
    },
    {
        "goal":  "존엄성 보장",
        "detail":  "도움이 필요한 피후견인(후견대상자)를 연계하여 공공후견인 지원한다."
    },
    {
        "goal":  "부동산 관리",
        "detail":  "법률적 지원 연계한다."
    },
    {
        "goal":  "재산관리",
        "detail":  "기타법률지원한다."
    },
    {
        "goal":  "가정 내 법률 문제 해결",
        "detail":  "무료 법률지원 서비스 안내한다."
    },
    {
        "goal":  "재산관리에 도움",
        "detail":  "성년후견인 연계한다."
    },
    {
        "goal":  "삶의 질 향상",
        "detail":  "성년후견인 관련 정보 제공한다."
    },
    {
        "goal":  "안전한 생활환경",
        "detail":  "읍면동 맞춤형 복지팀 연결 가정환경수정사업 지원한다."
    },
    {
        "goal":  "정서적 안정감 유지, 사회할동 유지 및 증진, 여가활동 유지 및 증진",
        "detail":  "정신행동증상 기본교육 제공한다."
    },
    {
        "goal":  "대화를 통해 정서적 안정감을 유지",
        "detail":  "사례관리자와 전화 및 방문 상담을 3회 이상 실시한다."
    },
    {
        "goal":  "대화를 통해 정서적 안정감을 유지",
        "detail":  "정서적 안정을 위해 월1회 이상 대면하여 상담을 제공한다."
    },
    {
        "goal":  "또래 모임 활동으로 사회성을 유지",
        "detail":  "노인돌봄 서비스 신청을 하여 도움 받도록 한다."
    },
    {
        "goal":  "정서적 안정감 유지",
        "detail":  "정서적 안정 지원한다."
    },
    {
        "goal":  "우울감, 고립감을 완화",
        "detail":  "주기적인 전화 및 방문을 통해 말벗서비스 제공한다."
    },
    {
        "goal":  "우울감 감소",
        "detail":  "주기적인 전화 및 방문을 통해 말벗서비스 제공한다."
    },
    {
        "goal":  "우울감 감소",
        "detail":  "전화상담을 통하여 말벗서비스를 실시한다."
    },
    {
        "goal":  "정서적 안정감 유지",
        "detail":  "말벗지원, 신체활동 증진시킬수 있는 운동 교육한다."
    },
    {
        "goal":  "사회활동 유지 및 증진",
        "detail":  "지역 내 여가시설 안내 및 이용 독려한다."
    },
    {
        "goal":  "삶의 활력 유지",
        "detail":  "취미/여가활동연계한다."
    },
    {
        "goal":  "취미, 연가활동을 유지",
        "detail":  "쉼터 활동 지지 및 격려, 활동 가능한 지역사회 모임에 대한 정보 제공한다."
    },
    {
        "goal":  "일상생활 적응 향상",
        "detail":  "쉼터 프로그램 관련 정보제공 및 연계한다."
    },
    {
        "goal":  "2달에 1권 이상 책을 읽을 수 있다.",
        "detail":  "치매독서코너에서 책을 대여한다."
    },
    {
        "goal":  "사회활동 유지 및 증진",
        "detail":  "치매카페 이용 격려한다."
    },
    {
        "goal":  "치매 질환 이해도 향상",
        "detail":  "치매안심센터 내 독서 코너 운영 안내한다."
    },
    {
        "goal":  "치매 질환 이해도 향상",
        "detail":  "치매관련도서연계한다."
    },
    {
        "goal":  "치매 질환 이해도 향상",
        "detail":  "치매관련도서에 대한 정보를 제공한다."
    },
    {
        "goal":  "정서적 안정감 유지",
        "detail":  "정서적 안정을 위한 말벗서비스 제공한다."
    },
    {
        "goal":  "의사소통 기술 향상",
        "detail":  "말벗서비스 연계한다."
    },
    {
        "goal":  "정서적안정감 유지",
        "detail":  "행정복지센터 독거노인서비스 신청안내한다."
    },
    {
        "goal":  "사회적 접촉과 교류의 기회",
        "detail":  "노인종합복지관 노노케어서비스 연계, 노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "스트레스 감소",
        "detail":  "말벗서비스 연계한다."
    },
    {
        "goal":  "대상자의 우울감 감소",
        "detail":  "말벗서비스 관련 정보 제공한다."
    },
    {
        "goal":  "다양한 지식 및 교양 습득",
        "detail":  "지역도서관 연계 한다."
    },
    {
        "goal":  "독서를 통한 성취감",
        "detail":  "지역도서관 연계한다."
    },
    {
        "goal":  "취미생활 유지",
        "detail":  "지역도서관 관련 정보를 제공한다."
    },
    {
        "goal":  "생활의 활력",
        "detail":  "취미/여가활동연계한다."
    },
    {
        "goal":  "여가활동유지 및 증진",
        "detail":  "복지관 취미교실담당자 연계한다."
    },
    {
        "goal":  "사회적 접촉과 교류의 기회를 가진다",
        "detail":  "노인종합복지관 프로그램 정보제공 및 연계한다."
    },
    {
        "goal":  "사회활동 참여 기회 확대",
        "detail":  "취미프로그램 연계한다."
    },
    {
        "goal":  "활기찬 생활을 영위",
        "detail":  "취미/여가활동연계한다."
    },
    {
        "goal":  "일상생활 적응도 향상",
        "detail":  "도서관 및 노인복지관 프로그램 정보 제공한다."
    },
    {
        "goal":  "사회적 부담 경감",
        "detail":  "가족교실 및 자조모임 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "스트레스를 해소하고 정서적 교류 도모",
        "detail":  "가족교실프로그램을 연계한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "가족교실 참여 권유한다."
    },
    {
        "goal":  "스트레스를 해소하고 정서적 교류 도모",
        "detail":  "자조모임, 힐링프로그램 등 운영 안내한다."
    },
    {
        "goal":  "경제적인 도움",
        "detail":  "가족지원프로그램 제공한다."
    },
    {
        "goal":  "돌봄부담을 경감",
        "detail":  "일상생활 수행의 어려움 여부 확인하고 돌봄기술 교육한다."
    },
    {
        "goal":  "가족응집력 협력 강화",
        "detail":  "가족교실 , 지조모임 관련 정보제공 및 연계 지원한다."
    },
    {
        "goal":  "치매환자를 이해",
        "detail":  "치매가족 힐링프로그램 제공한다."
    },
    {
        "goal":  "조호부담을 완화",
        "detail":  "가족프로그램 정보 제공한다."
    },
    {
        "goal":  "외출 기능향상",
        "detail":  "교통약자 이동서비스 안내한다."
    },
    {
        "goal":  "이동권 향상",
        "detail":  "치매관련 업무, 프로그램 참여시 택시 제공한다."
    },
    {
        "goal":  "생필품 구입 가능",
        "detail":  "교통이동지원연계한다."
    },
    {
        "goal":  "삶의 질 향상",
        "detail":  "교통이동지원 연계한다."
    },
    {
        "goal":  "대중교통 이용에 대한 스트레스를 감소",
        "detail":  "교통이동지원에 대한 정보 제공한다."
    },
    {
        "goal":  "외출과 외부 활동 시 안심",
        "detail":  "가스안전차단기 설치 사업을 연계한다."
    },
    {
        "goal":  "생활 환경수준 향상",
        "detail":  "청결을 위한 개인 위생관리 교육 제공한다."
    },
    {
        "goal":  "주기적 음식이나 생필품 지원",
        "detail":  "푸드뱅크 물품을 2회 이상 제공한다."
    },
    {
        "goal":  "일상생활관리 기능 향상",
        "detail":  "일상생활지원 관리서비스 연계한다."
    },
    {
        "goal":  "일상생활 도움",
        "detail":  "봉사자를 연결한다."
    },
    {
        "goal":  "주기적 투약 관리",
        "detail":  "지역의 치매파트너를 연결한다."
    },
    {
        "goal":  "정신행동증상에 대한 대처능력 향상",
        "detail":  "말벗 및 정서지원으로 안정감 유지한다."
    },
    {
        "goal":  "삶의 질 향상",
        "detail":  "봉사자 연계한다."
    },
    {
        "goal":  "청결한 가정 내에서 생활",
        "detail":  "지역 내 봉사단체 연계한다."
    },
    {
        "goal":  "생활에 필요한 물품을 지원",
        "detail":  "푸드뱅크 물품을 지원한다."
    },
    {
        "goal":  "일상생활에 필요한 물건을 이용",
        "detail":  "필요한 보호대를 제공한다."
    },
    {
        "goal":  "일상생활관리 기능 향상",
        "detail":  "기능수준에 적합한 물품 지원한다."
    },
    {
        "goal":  "경제적인 도움",
        "detail":  "생활용품지원연계한다."
    },
    {
        "goal":  "소지품 관리 능력을 향상",
        "detail":  "소지품 정리함을 제공하고, 사용방법을 교육한다."
    },
    {
        "goal":  "삶의 질을 향상",
        "detail":  "생활용품지원 연계한다."
    },
    {
        "goal":  "생활용품 지원을 통하여 삶의 질 향상",
        "detail":  "읍 면 생활용품 지원사업 연계한다."
    },
    {
        "goal":  "생활환경 개선으로 삶의 의욕 향상 / 지원을 통한 일상생활 수행",
        "detail":  "위생적 환경 조성, 위험한 물건 정리정돈을 통해 안전한 일상생활을 수행할수 있다."
    },
    {
        "goal":  "일상생활활동을 지원",
        "detail":  "조호물품 제공한다."
    },
    {
        "goal":  "경제적 부담 경감",
        "detail":  "조호물품 제공한다."
    },
    {
        "goal":  "조호물품 제공을 통한 경제적 어려움 해소",
        "detail":  "매년 기저귀 등 조호물품 제공한다."
    },
    {
        "goal":  "배변 위생관리",
        "detail":  "조호물품 설명 및 제공을 한다."
    },
    {
        "goal":  "경제적 부담감을 감소",
        "detail":  "조호물품 및 치료비 지원한다."
    },
    {
        "goal":  "일상생활에 필요한 물건을 이용",
        "detail":  "조호물품을 제공한다."
    },
    {
        "goal":  "지원체계 이용을 통한 경제적 부담완화",
        "detail":  "조호물품 제공한다."
    },
    {
        "goal":  "위생소몰품 제공으로 환자와 가족의 부담을 경감",
        "detail":  "기저귀 외 위생소모품 제공한다."
    },
    {
        "goal":  "개인위생 청결을 유지",
        "detail":  "조호물품 제공한다."
    },
    {
        "goal":  "개인위생관리 능력을 향상",
        "detail":  "요실금 대처를 위한 기저귀, 물티슈 등 위생용품 제공한다."
    },
    {
        "goal":  "개인위생 관리 유지",
        "detail":  "조호물품 제공한다."
    },
    {
        "goal":  "주보호자 경제적 부담 경감",
        "detail":  "가족교실 및 자조모임 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "조호부담 경감",
        "detail":  "조호물품 제공한다."
    },
    {
        "goal":  "신변처리 문제를 해결",
        "detail":  "조호물품 지원사업 정보를 제공한다."
    },
    {
        "goal":  "일상생활관리 기능 향상",
        "detail":  "가사간병서비스연계"
    },
    {
        "goal":  "보호자의 돌봄부담 경감",
        "detail":  "가사간병서비스연계"
    },
    {
        "goal":  "보호자의 돌봄부담 경감",
        "detail":  "노인장기요양보험 등급 신청 및 서비스 내용에 대한 정보제공"
    },
    {
        "goal":  "상황에 맞는 적절한 돌봄서비스 이용",
        "detail":  "지역내 사용가능한 방문간호 기관을 연계함."
    },
    {
        "goal":  "삶의 질 향상",
        "detail":  "가사간병서비스 정보 제공 및 연계"
    },
    {
        "goal":  "상황에 맞는 적절한 돌봄서비스 이용",
        "detail":  "가능한 돌봄서비스 확인 및 이용 격려 장기요양 서비스 이용 안내"
    },
    {
        "goal":  "상황에 맞는 적절한 돌봄서비스 이용",
        "detail":  "가사지원서비스연계"
    },
    {
        "goal":  "가사노동의 어려움 완화",
        "detail":  "관내 재가서비스센터 연계"
    },
    {
        "goal":  "가사관리 기능 향상",
        "detail":  "읍면 생활개선 서비스 지원 연계"
    },
    {
        "goal":  "상황에 맞는 적절한 돌봄서비스 이용",
        "detail":  "노인돌봄서비스와 장기요양서비스 재가급여제공기관을 연계함."
    },
    {
        "goal":  "상황에 맞는 적절한 돌봄서비스 이용",
        "detail":  "요양보호사 서비스 관련 정보 제공"
    },
    {
        "goal":  "교통이동지원을 받아 편리하게 이동",
        "detail":  "장애인콜택시 신청 및 연계한다."
    },
    {
        "goal":  "교통이동지원 서비스 이용",
        "detail":  "교통이동지원서비스를 연계한다."
    },
    {
        "goal":  "생필품을 스스로 구입",
        "detail":  "교통이동지원서비스연계한다."
    },
    {
        "goal":  "병원진료 등 외출",
        "detail":  "통합돌봄 케어택시 연계, 장애인 이동지원 서비스 연계한다."
    },
    {
        "goal":  "일상생활 유지 증진",
        "detail":  "노약자 교통지원 서비스 연계한다."
    },
    {
        "goal":  "안전하게 이동",
        "detail":  "교통이동지원서비스 연계한다."
    },
    {
        "goal":  "병의원 진료시 이동관련 불편함 감소",
        "detail":  "교통이동지원서비스를 안내한다"
    },
    {
        "goal":  "일상적인 활동",
        "detail":  "노인돌봄 서비스 신청을 하여 도움 받도록 한다."
    },
    {
        "goal":  "의사소통 기술 향상",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "식사 및 가사관리",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "일상생활 유지 증진",
        "detail":  "맞춤돌봄 서비스 연계 신청 및 상담 지원한다."
    },
    {
        "goal":  "적절한 돌봄서비스를 이용할수 있도록 지원",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "독거로 인한 우울감 감소",
        "detail":  "노인맞춤돌봄서비스 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "생활에 필요한 물품 지원",
        "detail":  "노인의료돌봄통합지원시범사업 정보를 제공한다."
    },
    {
        "goal":  "장기입원, 시설입소를 예방 및 재가 생활 유지",
        "detail":  "보건의료원 방문보건팀 연계, 긴급돌봄지원서비스 연계한다."
    },
    {
        "goal":  "돌봄에 대한 스트레스 감소",
        "detail":  "노인의료돌봄통합지원시범사업 정보를 제공한다."
    },
    {
        "goal":  "생활환경수준 향상",
        "detail":  "목욕차 서비스 안내 및 연결한다."
    },
    {
        "goal":  "상황에 맞는 적절한 돌봄서비스 이용",
        "detail":  "방문목욕서비스 연계한다."
    },
    {
        "goal":  "개인위생 청결 유지",
        "detail":  "방문목욕서비스 연계한다."
    },
    {
        "goal":  "청결을 유지하고 정서적 안정감 유지",
        "detail":  "장기요양보험 방문목욕 서비스 연계, 자원봉사센터 연계한다."
    },
    {
        "goal":  "일상생활 유지 증진",
        "detail":  "방문목욕서비스 연계한다."
    },
    {
        "goal":  "개인위생관리",
        "detail":  "목욕서비스 연계한다."
    },
    {
        "goal":  "청결하게 생활",
        "detail":  "장기요양서비스 정보 제공 및 재가복지센터 연계한다."
    },
    {
        "goal":  "일상생활관리 기능 향상",
        "detail":  "이불세탁 서비스 연계한다."
    },
    {
        "goal":  "개인위생 청결 유지",
        "detail":  "세탁서비스연계한다."
    },
    {
        "goal":  "품위와 청결 유지",
        "detail":  "사회복지관 세탁 서비스 연계한다."
    },
    {
        "goal":  "가사관리 기능향상",
        "detail":  "무료세탁서비스 지원 연계한다."
    },
    {
        "goal":  "개인위생관리",
        "detail":  "세탁서비스 연계한다."
    },
    {
        "goal":  "청결하게 생활",
        "detail":  "읍 면 행정복지센터 /복지관 세탁서비스 연계한다."
    },
    {
        "goal":  "필수 영양소 섭취",
        "detail":  "지역 내 복지관에 연계하여 서비스를 받도록 한다."
    },
    {
        "goal":  "일상생활관리 기능 향상",
        "detail":  "식사배달서비스 연계한다."
    },
    {
        "goal":  "균형잡힌 식사로 필요한 영양 섭취",
        "detail":  "지역유관기관과 연계한 반찬 서비스 제공한다."
    },
    {
        "goal":  "규칙적인 식사",
        "detail":  "식사배달서비스연계한다."
    },
    {
        "goal":  "균형잡힌 식사로 필요한 영양 섭취",
        "detail":  "통합돌봄과 주2회 영양보총식 밑반찬 배달서비스 연계한다."
    },
    {
        "goal":  "가사관리 기능향상",
        "detail":  "반찬나눔 서비스 지원 연계한다."
    },
    {
        "goal":  "식사기능향상",
        "detail":  "식사 도움이 필요한 대상자에게 적십자 밑반찬 지원서비스에 연계한다."
    },
    {
        "goal":  "필수 영양에 맞춰 식사",
        "detail":  "식사배달서비스 관련 정보를 제공한다."
    },
    {
        "goal":  "장기요양등급 신청 연계를 통한 일상생활 수행능력 향상",
        "detail":  "취사, 세탁, 청소등 주변 정리정돈 및 생활환경 관리 서비스를 제공한다."
    },
    {
        "goal":  "일상생활관리 기능 향상",
        "detail":  "재가노인 지원서비스 연계한다."
    },
    {
        "goal":  "일상생활 도움",
        "detail":  "재가노인지원서비스 연계한다."
    },
    {
        "goal":  "식사 및 가사관리",
        "detail":  "재가노인지원서비스 연계한다."
    },
    {
        "goal":  "일상생활 유지 증진",
        "detail":  "방문요양 서비스 연계한다."
    },
    {
        "goal":  "적절한 돌봄서비스를 이용할수 있도록 지원",
        "detail":  "노인돌봄서비스와 장기요양서비스 재가급여제공기관을 연계한다."
    },
    {
        "goal":  "가사에 대한 스트레스를 감소시킨다",
        "detail":  "재가노인지원서비스 정보 제공 및 연계한다."
    },
    {
        "goal":  "인지기능 저하로 인한 일상생활 문제 해결",
        "detail":  "치매공공후견을 통한 후견인 지정을 통해 일상생활 지원 및 사무관리의 도움 제공한다."
    },
    {
        "goal":  "위험요인 예방 및 개선",
        "detail":  "공공후견인 1:1 결연서비스 연계한다."
    },
    {
        "goal":  "의사결정을 지원하여 인간으로서의 존엄성 보장",
        "detail":  "공공후견인 활동 지원, 후견심판청구 지원한다."
    },
    {
        "goal":  "의사결정능력 저하로 인한 치매환자에게 존엄성 보장",
        "detail":  "도움이 필요한 피후견인(후견대상자)를 치매안심센터 담당자에게 연계하여 공공후견인 지원받을수 있도록 한다."
    },
    {
        "goal":  "생활 전반에 대한 의사결정 보조",
        "detail":  "공공후견인제도 관련 정보 제공한다."
    },
    {
        "goal":  "안전한 외출과 외부 활동",
        "detail":  "가스안전차단기 설치 사업을 연계한다."
    },
    {
        "goal":  "배회 및 가스화재 사고를 예방",
        "detail":  "가스안전차단기 신청서 접수한다."
    },
    {
        "goal":  "외출과 외부 활동 시 안심",
        "detail":  "지문등 사전등록을 안내한다."
    },
    {
        "goal":  "안전사고 대처능력 향상",
        "detail":  "실종 안내 가이드를 제공한다."
    },
    {
        "goal":  "실종 후 발견 시 신속하게 가정으로 복귀",
        "detail":  "지문등 사전등록 서비스를 제공한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "지문등 사전등록 서비스를 제공한다."
    },
    {
        "goal":  "신변지원을 위한 관리 강화",
        "detail":  "지문등 사전등록 서비스를 제공한다."
    },
    {
        "goal":  "안전한 환경을 조성",
        "detail":  "지문등 사전등록 서비스를 제공한다."
    },
    {
        "goal":  "외출시 안전하게 활동하고 귀가",
        "detail":  "지문등 사전등록 서비스를 제공한다."
    },
    {
        "goal":  "화재 예방",
        "detail":  "가스안전차단기를 연 1회 설치 지원한다."
    },
    {
        "goal":  "낙상예방을 위한 교육제공",
        "detail":  "낙상예방 보행법을 교육하고 안내제공한다."
    },
    {
        "goal":  "가정에서 낙상의 위험없이 안전한 생활",
        "detail":  "낙상예방교육을 실시한다."
    },
    {
        "goal":  "가정에서 낙상의 위험없이 안전한 생활",
        "detail":  "낙상 예방교육을 실시한다. 낙상 예방을 위한 보조용품으로 지팡이를 제공한다."
    },
    {
        "goal":  "가정에서 낙상의 위험없이 안전한 생활",
        "detail":  "낙상 예방교육을 실시한다. 안전한 보행을 돕기위한 보조기구 및 지팡이를 제공한다."
    },
    {
        "goal":  "안전사고예방",
        "detail":  "낙상예방교육을 실시한다."
    },
    {
        "goal":  "안전사고예방",
        "detail":  "낙상예방교육을 월 1회 이상 진행한다"
    },
    {
        "goal":  "안전사고예방",
        "detail":  "낙상예방을 위해 화장실 안전손잡이를 설치한다"
    },
    {
        "goal":  "응급상황예방",
        "detail":  "낙상예방교육한다."
    },
    {
        "goal":  "일상생활 낙상예방",
        "detail":  "낙상예방교육제공 및 낙상예방 물품 제공한다."
    },
    {
        "goal":  "위험요인 예방 및 개선",
        "detail":  "낙상과 사고방지 교육 및 낙상예방을 위한 보조기구 지원한다."
    },
    {
        "goal":  "낙상 예방법 인지",
        "detail":  "가정방문, 프로그램 운영시 낙상예방법 안내한다."
    },
    {
        "goal":  "일상생활 낙상예방",
        "detail":  "낙상교육 제공 한다."
    },
    {
        "goal":  "일상생활 낙상예방",
        "detail":  "낙상예방 보조물품 지원 및 낙상예방교육 제공한다."
    },
    {
        "goal":  "낙상사고 위험성 감소",
        "detail":  "안전스티커 배부 및 낙상예방 수칙교육한다."
    },
    {
        "goal":  "일상생활 낙상예방",
        "detail":  "봉사단체 연계 수정 및 미끄럼방지 매도 제공한다."
    },
    {
        "goal":  "일상생활 낙상예방",
        "detail":  "가정방문시 낙상예방을 위한 교육 제공한다."
    },
    {
        "goal":  "일상생활 낙상예방",
        "detail":  "관절, 근육 강화 운동을 교육한다."
    },
    {
        "goal":  "일상생활 낙상예방",
        "detail":  "낙상예방 물품 제공한다."
    },
    {
        "goal":  "낙상 방지",
        "detail":  "가온체크리스트컨설팅 체크리스트에 따른 환경수정 제공한다. (안전손잡이, 미끄럼방지용품 등)"
    },
    {
        "goal":  "배회감지기 등록",
        "detail":  "필요 서류 구비 해서 보호자와 보건소 방문 교육한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회감지기 GPS를 제공한다."
    },
    {
        "goal":  "안전한 외출과 외부활동",
        "detail":  "배회감지기 지원사업을 안내한다."
    },
    {
        "goal":  "위험요인 예방 및 개선",
        "detail":  "배회감지기 제공한다."
    },
    {
        "goal":  "실종시 빠르게 대처",
        "detail":  "배회감지기 제공한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "노인장기요양등급자에게 복지용구 배회감지기에 대여사업 대한 정보 제공 및 이용 격려한다."
    },
    {
        "goal":  "배회사고 위험성 감소",
        "detail":  "배회감지기 지원 제공한다."
    },
    {
        "goal":  "배회로 인한 사고발생 위험성 감소 및 예방",
        "detail":  "배회로 인해 대상자의 위치를 파악할수 있도록 배회감지기를 무상지급하고 사용법을 안내한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "배회감지기 제공 및 관리한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "배회감지기 제공한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "배회감지기 사업 안내 및 발급한다."
    },
    {
        "goal":  "안전한 일상생활 유지",
        "detail":  "배회가능성 대상자에게 배회인식표를 발급한다."
    },
    {
        "goal":  "안전한 일상생활 유지",
        "detail":  "배회로 인식표 제공한다.(배회감지기, 지문인식 등 여러가지 실종대비 방법을 안내한다)"
    },
    {
        "goal":  "위험요인 예방 및 개선",
        "detail":  "배회인식표 발급한다."
    },
    {
        "goal":  "실종 후 발견 시 신속하게 가정으로 복귀할 수 있도록 한다.",
        "detail":  "인식표 및 보호자용 실종대응카드 제공한다."
    },
    {
        "goal":  "실종시 빠르게 대처할 수 있다",
        "detail":  "배회인식표 제공한다."
    },
    {
        "goal":  "배회사고 위험성 감소",
        "detail":  "인식표 지원 제공한다."
    },
    {
        "goal":  "배회로 인한 사고발생 위험성 감소 및 예방",
        "detail":  "배회인식표 제공한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "배회인식표 제공한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "배회인식표 사업 안내 및 제공한다."
    },
    {
        "goal":  "생활환경 안전에 대한 인식 향상 및 실천",
        "detail":  "가정환경수정사업을 통한 안전관리교육 제공한다."
    },
    {
        "goal":  "실내 안전사고를 예방",
        "detail":  "생활환경 안전에 대한 인식을 개선하고 실천할 수 있도록 지원한다."
    },
    {
        "goal":  "안전한 일상생활을 유지",
        "detail":  "대상자에게 화재예방을 위한 가정용 소화기를 교육, 제공한다."
    },
    {
        "goal":  "안전사고 대처능력 향상",
        "detail":  "낙상과 사고방지, 화재 안전점검 등 교육한다."
    },
    {
        "goal":  "안전사고 위험 감소",
        "detail":  "안전관리교육제공한다."
    },
    {
        "goal":  "안전사고를 예방",
        "detail":  "횡단보도 이용하기, 도로에서 전동차 이용 자제하기 등 안전사고예방교육 제공한다."
    },
    {
        "goal":  "일상생활 안전 관리 강화",
        "detail":  "안전스티커 배부 및 응급상황 수칙교육한다."
    },
    {
        "goal":  "안전에 대한 인식 향상 및 실천",
        "detail":  "가정방문시 주거환경 점검하고 낙상, 화재예방, 전기장판 과열로 인한 사고등에 대비한 안전교육 시행한다."
    },
    {
        "goal":  "안전 문제에 관한 인식을 개선",
        "detail":  "안전관리교육제공한다."
    },
    {
        "goal":  "안전관리에 대한 의식도 향상",
        "detail":  "안전관리 교육을 실시한다."
    },
    {
        "goal":  "생활환경수준 향상",
        "detail":  "가정환경수정사업을 통한 안전관리물품 제공한다."
    },
    {
        "goal":  "화장실을 이용할 때 낙상을 예방",
        "detail":  "화장실 안전바, 미끄럼방지매트를 설치 및 지원한다."
    },
    {
        "goal":  "화재 위험 상황을 예방",
        "detail":  "가스안전차단기 설치를 지원한다."
    },
    {
        "goal":  "외출과 외부활동시 안전하게 이동",
        "detail":  "안전한 보행을 돕기 위한 지팡이를 제공한다."
    },
    {
        "goal":  "가스안전 차단기를 설치하여 생활 속 화재 위험 요소를 제거",
        "detail":  "가스안전 차단기 설치를 지원한다."
    },
    {
        "goal":  "화장실에 안전 손잡이를 설치하여 낙상의 위험으로부터 보호",
        "detail":  "화장실 안전손잡이 설치를 지원한다."
    },
    {
        "goal":  "위험인자를 예방 및 제거",
        "detail":  "미끄럼방지 매트, 화장실 야간 조명등 제공한다."
    },
    {
        "goal":  "안전한 일상생활 유지",
        "detail":  "대상자에게 화재예방을 위한 교육을 시행한다."
    },
    {
        "goal":  "안전사고 대처능력 향상",
        "detail":  "가정환경수정사업 주거환경 개선한다."
    },
    {
        "goal":  "안전사고 대처능력 향상",
        "detail":  "안전관리물품제공한다."
    },
    {
        "goal":  "집안에서의 낙상사고 예방",
        "detail":  "가정환경 안심스티커 부착한다."
    },
    {
        "goal":  "화재예방",
        "detail":  "가스안전차단기 설치 지원한다."
    },
    {
        "goal":  "일상생활 안전 관리 강화",
        "detail":  "미끄럼방지및 미끄럼 방지 스티커 1회 양말 제공한다."
    },
    {
        "goal":  "안전한 환경을 조성",
        "detail":  "안전관리물품제공한다."
    },
    {
        "goal":  "안전관리에 대한 의식도 향상",
        "detail":  "안전관리 관련 물품을 제공한다."
    },
    {
        "goal":  "응급상황 해결",
        "detail":  "가스안전차단기 설치 자원 연계한다."
    },
    {
        "goal":  "가정에서 가스를 안전하게 사용",
        "detail":  "가스안전차단기 설치 자원 연계한다."
    },
    {
        "goal":  "안전한 생활환경에서 거주",
        "detail":  "가스안전차단기 설치 자원 연계한다."
    },
    {
        "goal":  "화재위험 대비",
        "detail":  "가스안전차단기 설치 자원 연계한다."
    },
    {
        "goal":  "화재 예방",
        "detail":  "가스안전차단기 설치 사업 기관에 연계한다."
    },
    {
        "goal":  "화재 위험성 감소",
        "detail":  "가스안전차단 장치 설치 및 고장 수리 연계 및 상담 제공한다."
    },
    {
        "goal":  "인지저하로 인한 일상생활 사고위험 감소",
        "detail":  "무료 가스타이머콕 보급 연계한다."
    },
    {
        "goal":  "화재 위험성 예방",
        "detail":  "가스안전차단기 설치 서비스 연계한다."
    },
    {
        "goal":  "사고방지",
        "detail":  "가스안전차단기 설치 자원 연계한다."
    },
    {
        "goal":  "가정 내 화재예방",
        "detail":  "가스안전차단기 설치 자원 연계한다."
    },
    {
        "goal":  "안전한 생활을 영위",
        "detail":  "지문 등록 연계한다."
    },
    {
        "goal":  "외출과 외부 활동 시 안심",
        "detail":  "지문등 사전등록을 연계한다."
    },
    {
        "goal":  "안전사고 대처능력 향상",
        "detail":  "지문등 사전등록을 연계한다."
    },
    {
        "goal":  "실종 후 발견 시 신속하게 가정으로 복귀",
        "detail":  "경찰청시스템에 지문, 사진, 보호자 연락처 등 사전 등록을 연계한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "지문등 사전등록을 연계한다."
    },
    {
        "goal":  "신변지원을 위한 관리 강화",
        "detail":  "지문등 사전등록을 연계한다."
    },
    {
        "goal":  "실종예방",
        "detail":  "실종 및 길 잃음 발생예방을 위해 경찰서지문등록사업에 연계한다."
    },
    {
        "goal":  "안전한 환경을 조성",
        "detail":  "지문등 사전등록을 연계한다."
    },
    {
        "goal":  "응급상황 대처능력 확보",
        "detail":  "응급벨 설치 지원 연계한다."
    },
    {
        "goal":  "신변지원을 위한 관리 강화",
        "detail":  "응급벨 신청 연계한다."
    },
    {
        "goal":  "신변지원을 위한 관리 강화",
        "detail":  "고독사예방 서비스 연계한다."
    },
    {
        "goal":  "고독사 예방",
        "detail":  "응급벨설치 관련 정보를 제공 및 연계한다."
    },
    {
        "goal":  "낙상위험성 감소",
        "detail":  "보행보조기 사용법을 교육하고 확인한다"
    },
    {
        "goal":  "생활환경 안전 위험요인 확인",
        "detail":  "보조기구 지원 연계 및 복지용구 정보제공한다."
    },
    {
        "goal":  "안전한 생활",
        "detail":  "낙상예방 보조기구 연계한다."
    },
    {
        "goal":  "신체부상 예방",
        "detail":  "자원봉사센터 연계한다."
    },
    {
        "goal":  "낙상 예방",
        "detail":  "낙상예방 보조기구 제공 서비스 연계한다."
    },
    {
        "goal":  "내, 외부 안전한 활동",
        "detail":  "지역 내 보조기구 대여 서비스 정보 안내한다."
    },
    {
        "goal":  "안전사고 대처능력 향상",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "안전한 재가 생활 유지",
        "detail":  "노인맞춤돌봄서비스 방문안전서비스 연계한다."
    },
    {
        "goal":  "신변지원을 위한 관리 강화",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "안전한 환경 조성",
        "detail":  "노인맞춤돌봄서비스 연계한다."
    },
    {
        "goal":  "대상자의 우울감 감소",
        "detail":  "노인맞춤돌봄서비스 관련 정보 제공한다."
    },
    {
        "goal":  "응급상황 발생 시 대처",
        "detail":  "응급안전안심서비스 연계한다."
    },
    {
        "goal":  "노인학대 예방 및 지지체계 확보",
        "detail":  "학대 및 응급상황 발생시 연계한다."
    },
    {
        "goal":  "응급상황 지지체계 확보",
        "detail":  "지역사회 관계망 구축 및 응급상황에 대한 교육제공한다."
    },
    {
        "goal":  "은둔형 치매노인의 사회화",
        "detail":  "정서지원 프로그램 연계, 정서적안정유지"
    },
    {
        "goal":  "신변지원을 위한 관리 강화",
        "detail":  "노인학대 상담 및 관리 신청연계"
    },
    {
        "goal":  "안전한 환경 조성",
        "detail":  "노인보호전문기관 서비스 연계"
    },
    {
        "goal":  "노인학대의 위험 감소",
        "detail":  "노인보호전문기관 정보제공"
    },
    {
        "goal":  "응급 상황에 대처",
        "detail":  "응급 상황 대처를 위해 119응급안심서비스를 신청한다"
    },
    {
        "goal":  "응급시 빠르게 대처",
        "detail":  "응급안전 서비스 연계한다."
    },
    {
        "goal":  "치매노인의 사고 예방",
        "detail":  "복지관 응급안전서비스 연계한다."
    },
    {
        "goal":  "안전한 재가 생활을 유지",
        "detail":  "응급안전안심 서비스 연계한다."
    },
    {
        "goal":  "안전한 환경 조성",
        "detail":  "지역사회기관 응급안전서비스 연계한다."
    },
    {
        "goal":  "응급상황에 대처",
        "detail":  "지역사회기관 응급안전서비스 관련정보 제공한다."
    },
    {
        "goal":  "낙상예방, 건강관리유지",
        "detail":  "미끄럼방지매트 설치한다."
    },
    {
        "goal":  "낙상예방, 건강관리유지",
        "detail":  "양변기 안전손잡이 제공한다."
    },
    {
        "goal":  "쾌적한 주거환경 조성",
        "detail":  "청소 및 방역서비스를 제공한다."
    },
    {
        "goal":  "집 내부활동시 안전하게 활동",
        "detail":  "가온체크리스트컨설팅, 체크리스트에 따른 환경수정을 제공한다. (안전손잡이, 미끄럼방지용품 등)"
    },
    {
        "goal":  "생활환경 안전 위험요인 제거",
        "detail":  "주거환경을 개선한다."
    },
    {
        "goal":  "집 내부활동시 안전하게 활동",
        "detail":  "가정환경수정 서비스를 제공한다."
    },
    {
        "goal":  "주거환경 개선을 통한 안전한 주거환경 조성",
        "detail":  "주거환경 개선 사업 대상자 연계를 통한 가정내 미끄럼 방지 매트 및 안전바 설치 제공한다."
    },
    {
        "goal":  "생활환경 안전 위험요인 제거",
        "detail":  "가정환경수정사업 주거환경 개선한다."
    },
    {
        "goal":  "집 내부활동시 안전하게 활동",
        "detail":  "낙상과 사고방지 교육한다."
    },
    {
        "goal":  "지역사회의 도움",
        "detail":  "지역사회 연계한다."
    },
    {
        "goal":  "안전한 재가 생활을 유지",
        "detail":  "가정환경수정서비스제공한다."
    },
    {
        "goal":  "생활 환경 수준 향상",
        "detail":  "주거환경 개선 서비스 지원한다."
    },
    {
        "goal":  "안전한 환경을 조성",
        "detail":  "주거환경 개선 지원한다."
    },
    {
        "goal":  "대상자가 청결한 상태에 거주",
        "detail":  "지역 내 봉사자 및 봉사단체 연계한다."
    },
    {
        "goal":  "많아진 길고양이들로 인한 스트레스 해소를 위해 중성화 수술 서비스를 신청하고 길고양이 개체수 증가를 막을 수 있다.",
        "detail":  "길고양이 중성화 수술 서비스에 대해 안내하고 신청을 안내한다."
    },
    {
        "goal":  "위생관리",
        "detail":  "손씻기세제 배부와 손씻기 방법교육"
    },
    {
        "goal":  "위생관리",
        "detail":  "청결을 위한 개인 위생관리 교육 시행"
    },
    {
        "goal":  "쾌적한 환경에서 생활",
        "detail":  "정리수납 서비스를 연계한다."
    },
    {
        "goal":  "생활환경 안전 위험요인 확인",
        "detail":  "집안 정리정돈 서비스 연계한다."
    },
    {
        "goal":  "낙상의 위험 예방",
        "detail":  "집안 정리정돈 서비스 연계한다."
    },
    {
        "goal":  "청결과 건강을 유지",
        "detail":  "주거공간 건강, 클린사업 연계한다."
    },
    {
        "goal":  "낙상사고를 예방",
        "detail":  "집안 정리정돈 서비스 연계한다."
    },
    {
        "goal":  "쾌적한 환경에서 생활",
        "detail":  "청소 및 방역서비스를 연계한다."
    },
    {
        "goal":  "생활환경 안전 위험요인 확인",
        "detail":  "청소 및 방역서비스 연계한다."
    },
    {
        "goal":  "깨끗하고 청결한 환경 유지",
        "detail":  "청소 및 방역서비스 서비스 연계한다."
    },
    {
        "goal":  "이웃과의 갈등을 완화",
        "detail":  "강박대상자 집청소 서비스 신청보조한다."
    },
    {
        "goal":  "청결하고 위생적인 환경을 조성",
        "detail":  "청소 및 방역서비스 서비스 연계한다."
    },
    {
        "goal":  "대상자가 청결한 상태 거주",
        "detail":  "청소 및 방역서비스 관련 업체 정보 제공한다."
    },
    {
        "goal":  "생활환경 안전 위험요인 확인",
        "detail":  "토탈협업케어서비스 연계한다."
    },
    {
        "goal":  "안전한 생활을 영위",
        "detail":  "토탈협업케어서비스 연계한다."
    },
    {
        "goal":  "삶의 질 향상",
        "detail":  "토탈협업케어서비스 연계한다."
    },
    {
        "goal":  "우울감 개선 및 사회적 교류증진",
        "detail":  "치매힐링프로그램을 1회 운영한다."
    },
    {
        "goal":  "안전하고 편리하게 이동",
        "detail":  "교통약자 서비스 제공한다.(택시)"
    },
    {
        "goal":  "주기적인 진료를 통한 건강관리",
        "detail":  "치매관리주치의 정보 제공한다."
    },
    {
        "goal":  "적절한 치료를 통한 치매 중증도 지연",
        "detail":  "입원치료 서비스 제공한다."
    },
    {
        "goal":  "신체활동으로 인한 안전사고를 예방하고 응급상황에 대처",
        "detail":  "홍보물과 영상등 이용한 교육을 제공한다."
    },
    {
        "goal":  "일상생활을 안전하고 활동",
        "detail":  "배회 인식표 제공한다."
    },
    {
        "goal":  "외출시 안전하게 활동하고 귀가",
        "detail":  "지문등 사전등록을 연계한다."
    },
    {
        "goal":  "사회적 접촉을 통한 인지기능을 유지",
        "detail":  "AI를 통한 전반적인 돌봄을 제공한다."
    },
    {
        "goal":  "인지기능의 유지",
        "detail":  "인지 워크북 제공 및 교육한다."
    },
    {
        "goal":  "질병의 올바른 인식과 발병기전에 대처",
        "detail":  "치매 동영상과 교육자료, 책을 제공한다."
    },
    {
        "goal":  "정기적인 진료와 약물 관리를 통한 건강관리",
        "detail":  "치매치료비 제공한다."
    },
    {
        "goal":  "정기적인 건강관리",
        "detail":  "치매치료비 제공한다."
    },
    {
        "goal":  "사고 예방",
        "detail":  "장기요양등급 서비스를 이용하여 복지용품을 제공한다."
    },
    {
        "goal":  "지속적인 돌봄을 제공하여 자극을 최적화",
        "detail":  "장기요양등급 서비스 이용 제공한다."
    },
    {
        "goal":  "인지 기능을 자극하여 치매중증화 지연",
        "detail":  "센터 내 프로그램 다양한 교육을 제공한다."
    },
    {
        "goal":  "정신적 부담 경감",
        "detail":  "치매와 정신행동증상 대처 기술 교육한다."
    },
    {
        "goal":  "원활한 대상자 케어",
        "detail":  "상담을 통해 돌봄부담 지지 및 격려한다."
    },
    {
        "goal":  "돌봄부담 감소",
        "detail":  "정기적인 방문을 통해 대상자의 돌봄부담에 대해 상담하고 공감 및 지지를 제공한다."
    },
    {
        "goal":  "가족들이 따뜻한 말을 건넬수 있다.",
        "detail":  "배우자가 와상상태라서 대상자와 주보호자 따님에게 정서적 지지한다."
    },
    {
        "goal":  "가족들에게 짜증내지 않고 감사하다고 말할수 있다.",
        "detail":  "배우자에게 하루에 3번 고맙다고 말할 수 있도록 교육한다."
    },
    {
        "goal":  "가족의 심리적인 부담감 감소",
        "detail":  "가족심층상담을 실시한다."
    },
    {
        "goal":  "주조호자와 적절한 관계를 형성하고 부담을 경감",
        "detail":  "치매 돌봄기술을 정기적으로 교육한다"
    },
    {
        "goal":  "가족의 문제점을 해소",
        "detail":  "가족 상담 지원한다."
    },
    {
        "goal":  "스트레스, 부양부담을 경감",
        "detail":  "주보호자 건강관리 상담, 치매 및 동반질환 관련 가족 상담 제공한다."
    },
    {
        "goal":  "가족내 협응 능력 강화",
        "detail":  "치매및 동반질환 관련 가족 상담한다."
    },
    {
        "goal":  "돌봄 대처능력 향상을 통한 스트레스 경감",
        "detail":  "치매안심센터에서 가족상담을 받을 수 있도록 연결하고 가족교실 및 자조모임을 이용하도록 한다."
    },
    {
        "goal":  "가족에게 심리적 안정감을 제공",
        "detail":  "가족상담지원 연계한다."
    },
    {
        "goal":  "주보호자 돌봄 대처능력 향상",
        "detail":  "가족교실 및 자조모임 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "돌봄제공자에게 정서적 지지",
        "detail":  "돌봄제공자 헤아림 프로그램 연결한다."
    },
    {
        "goal":  "가족의 심리적인 부담감 감소",
        "detail":  "가족 힐링프로그램 참여도록 한다."
    },
    {
        "goal":  "주조호자와 적절한 관계를 형성하고 부담을 경감",
        "detail":  "가족교실 및 자조모임 관련 정보를 제공한다."
    },
    {
        "goal":  "치매환자 돌봄에 대한 부담 감소",
        "detail":  "가족지원 프로그램 제공한다."
    },
    {
        "goal":  "돌봄이해, 돌봄역량을 향상",
        "detail":  "가족교실 및 자조모임 정보제공 및 연계한다."
    },
    {
        "goal":  "가족의 돌봄기능 향상",
        "detail":  "가족교실 및 자조모임 정보제공 및 연계한다."
    },
    {
        "goal":  "돌봄 대처능력 향상을 통한 스트레스 경감",
        "detail":  "치매안심센터에서 가족상담을 받을 수 있도록 연결하고 가족교실 및 자조모임을 이용하도록한다."
    },
    {
        "goal":  "보호자가 치매를 이해하고 올바르게 대처",
        "detail":  "헤아림(치매가족교실) 프로그램에 주호자를 참여시킨다."
    },
    {
        "goal":  "가족에게 심리적 안정감을 제공",
        "detail":  "가족지원프로그램 연계한다."
    },
    {
        "goal":  "보호자가 대상자 특성에 대해서 이해",
        "detail":  "주 보호자 돌봄부담분석 시행 후 결과 상담을 실시한다."
    },
    {
        "goal":  "보호자가 돌봄에 대한 어려움을 공감",
        "detail":  "돌봄부담분석을 제공한다."
    },
    {
        "goal":  "조호자의 돌봄부담 감소",
        "detail":  "정기적 상담을 통한 정서적 지지를 제공한다."
    },
    {
        "goal":  "돌봄부담 스트레스를 경감",
        "detail":  "돌봄부담분석 시행함, 보호자 헤아림 교실 연계 및 힐링프로그램 참석 유도한다."
    },
    {
        "goal":  "주조호자와 적절한 관계를 형성하고 부담을 경감",
        "detail":  "돌봄부담분석을 진행한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "정신건강 복지센터 서비스 연계한다."
    },
    {
        "goal":  "주조호자 스트레스 감소",
        "detail":  "돌봄부담 분석 실시한다."
    },
    {
        "goal":  "돌봄부담을 경감",
        "detail":  "보호자 돌봄부담분석을 시행, 돌봄부담완화를 위한 상담 제공한다."
    },
    {
        "goal":  "가족 돌봄 부담 완화",
        "detail":  "가족상담 제공한다."
    },
    {
        "goal":  "치매안심센터 서비스 이용을 통한 돌봄부담 경감",
        "detail":  "치매가족 돌봄부담분석을 체크리스트 통해 시행하고 결과에 따라 가족상담을 받을수 있도록 자조모임교실을 센터에 연계한다."
    },
    {
        "goal":  "주호자 돌봄능력 향상",
        "detail":  "치매지원 서비스에 대한 및 가족교실 및 자조모임 관련 정보 제공 및 연계한다."
    },
    {
        "goal":  "돌봄과 관련한 부담감 경감",
        "detail":  "가족지원프로그램 연계한다."
    },
    {
        "goal":  "우울감 감소",
        "detail":  "한글판 우울증 선별도구 검사시행한다."
    },
    {
        "goal":  "대상자의 조호부담 경감",
        "detail":  "돌봄부담분석을 실시한다."
    },
    {
        "goal":  "경제적 부담 경감",
        "detail":  "주조호자 치료 연계한다."
    },
    {
        "goal":  "건강한 생활을 유지",
        "detail":  "돌봄부담 감소를 위해 가족상담을 지원한다."
    },
    {
        "goal":  "우울감을 해소하고 활기 되찾기",
        "detail":  "정기적인 가족상담을 지원한다."
    },
    {
        "goal":  "조호물품 지원",
        "detail":  "사례관리를 통한 조호물품 지원 사업 연계제공한다."
    },
    {
        "goal":  "돌봄 가이드 북 제공 및 교육",
        "detail":  "가이드북 제공 및 교육한다."
    },
    {
        "goal":  "신체적, 정신적, 경제적, 사회적 부담을 경감",
        "detail":  "정서지원상담, 조호물품 제공, 건강관리상담, 주거환경개선 등 제공한다."
    },
    {
        "goal":  "돌봄과 관련한 어려움을 파악",
        "detail":  "가족지원프로그램 연계한다."
    },
    {
        "goal":  "조호자의 욕구를 파악하여 서비스를 제공",
        "detail":  "맞춤형사례관리 실시를 통해 관련 서비스 연계한다."
    },
    {
        "goal":  "주보호자와 적절한 관계형성을 유지",
        "detail":  "사례관리 서비스 제공한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "지역 내 여가시설 안내 및 이용 독려한다."
    },
    {
        "goal":  "돌봄 스트레스 감소",
        "detail":  "프로그램 제공한다."
    },
    {
        "goal":  "심리적 안정감",
        "detail":  "가족교실참여, 타인과의 감정적 교류한다."
    },
    {
        "goal":  "문화, 여가, 취미 활동을 유지",
        "detail":  "대상자 상황에 맞는 적절한 돌봄서비스 기관 연계한다."
    },
    {
        "goal":  "가족의 기분 전환",
        "detail":  "문화‧여가‧취미 활동 지원 서비스 연계한다."
    },
    {
        "goal":  "조호자의 우울감 감소",
        "detail":  "지역 내 문화 및 여가 정보 제공한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "일자리사업 정보제공 및 연계한다."
    },
    {
        "goal":  "경제적인 도움",
        "detail":  "일자리 서비스 연계한다."
    },
    {
        "goal":  "보호자의 경제적 부담경감 완화",
        "detail":  "공공근로 일자리 지원서류 작성보조를 제공한다."
    },
    {
        "goal":  "가족요양등 정보 제공",
        "detail":  "소득지원 및 일자리 서비스 연계한다."
    },
    {
        "goal":  "조호자의 경제적 부담 감소",
        "detail":  "지역 내 일자리 정보를 제공한다."
    },
    {
        "goal":  "경제적 조호부담 경감",
        "detail":  "조호자에게 일자리 서비스 제공한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "가족교실 및 자조모임 정보제공 및 연계한다."
    },
    {
        "goal":  "소통으로 공감 할 수 있는 기회",
        "detail":  "외부기관 자조모임 서비스 연계한다."
    },
    {
        "goal":  "기분전환 및 정보를 제공한다",
        "detail":  "외부기관 자조모임 서비스 연계한다."
    },
    {
        "goal":  "조호자의 우울감을 감소시킨다",
        "detail":  "자조모임 관련 정보를 제공한다."
    },
    {
        "goal":  "조호자의 돌봄부담 감소",
        "detail":  "장기요양서비스 안내 및 장기요양서비스 대리 접수한다."
    },
    {
        "goal":  "안전한 일상생활을 유지",
        "detail":  "요양등급 서비스에 대해 설명 및 지원하도록 안내한다."
    },
    {
        "goal":  "보호자 돌봄 부담을 완화",
        "detail":  "장기 요양 서비스 이용 절차와 방법에 대하여 설명한다."
    },
    {
        "goal":  "보호자 돌봄 부담을 완화",
        "detail":  "보호자 돌봄 완화를 위한 교육 및 정서적 지지한다."
    },
    {
        "goal":  "보호자 돌봄 부담을 완화",
        "detail":  "장기 요양 서비스 이용에 대한 모니터링한다."
    },
    {
        "goal":  "보호자 돌봄 부담을 완화",
        "detail":  "주간보호센터 선택 시 체크리스트 제공 및 설명한다."
    },
    {
        "goal":  "방문요양서비스 이용을 통한 돌봄부담 감소",
        "detail":  "방문요양 서비스 이용을 통해 보호자 돌봄부담 경감 및 치매가족휴가제 이용 안내한다."
    },
    {
        "goal":  "주조호자와 적절한 관계 형성 및 부담 경감",
        "detail":  "장기요양서비스에 대한 정보를 제공한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "장기요양 서비스 권유 및 정보제공한다."
    },
    {
        "goal":  "주조호자의 돌봄 부담 감소",
        "detail":  "노인장기요양서비스 안내한다."
    },
    {
        "goal":  "조호자의 돌봄부담을 완화",
        "detail":  "장기용양등급신청 준비 서류 안내한다."
    },
    {
        "goal":  "돌봄부담을 경감",
        "detail":  "노인장기요양기관 연계한다."
    },
    {
        "goal":  "가족의 돌봄 부담 완화",
        "detail":  "장기요양 서비스 연계한다."
    },
    {
        "goal":  "정신적,신체적,경제적 부담 경감",
        "detail":  "노인장기요양보험 본인부담금 안내 및 연계한다."
    },
    {
        "goal":  "장기요양서비스 이용으로 조호부담 경감",
        "detail":  "장기요양서비스 연계한다."
    },
    {
        "goal":  "조호자의 돌봄부담을 감소",
        "detail":  "장기요양서비스 관련 정보 제공한다."
    },
    {
        "goal":  "주조호자와 적절한 관계를 형성하고 부담을 경감",
        "detail":  "치매가족휴가제 정보를 제공한다."
    },
    {
        "goal":  "치매 대처능력 향상 및 유지",
        "detail":  "치매가족휴가제 정보제공 및 연계한다."
    },
    {
        "goal":  "힐링의 시간을 가진다",
        "detail":  "프로그램 제공한다."
    },
    {
        "goal":  "재가 생활을 유지하고 돌봄부담을 경감",
        "detail":  "치매환자 단기보호 서비스를 제공하는 장기요양기관 연계한다."
    },
    {
        "goal":  "돌봄가족에게 휴식을 제공",
        "detail":  "치매가족휴가제 안내한다."
    },
    {
        "goal":  "조호자에게 심리적 안정감을 제공",
        "detail":  "치매가족휴가제 관련 정보를 제공한다."
    },
    {
        "goal":  "정리정돈된 환경에서 안정감",
        "detail":  "정리정돈 서비스 제공한다."
    },
    {
        "goal":  "깨끗한 환경에서 안전하게 생활",
        "detail":  "방역 청소 서비스 제공한다."
    },
    {
        "goal":  "대상자가 영양관리의 필요성을 인식할 수 있다.",
        "detail":  "담당자가 쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "대상자가 위생상태를 향상할 수 있다.",
        "detail":  "담당자가 찾아가는 쉼터 프로그램을 제공한다."
    },
    {
        "goal":  "대상자가 운동의 중요성을 인지할 수 있다.",
        "detail":  "담당자가 쉼터 이용을 위한 이동 및 활동 참여를 지원한다."
    },
    {
        "goal":  "대상자가 질병으로 인한 고통을 감소시킬 수 있다.",
        "detail":  "담당자가 방문형 인지 키트를 제공한다."
    },
    {
        "goal":  "대상자가 현 질병 상태를 유지하고 악화를 방지할 수 있다.",
        "detail":  "담당자가 인지 강화 활동지 및 색칠북을 제공한다."
    },
    {
        "goal":  "대상자가 치매노인의 건강에 대한 이해도를 향상할 수 있다.",
        "detail":  "담당자가 인지 재활 학습 교구 및 퍼즐을 제공한다."
    },
    {
        "goal":  "대상자가 신체적 부담 경감으로 건강을 개선할 수 있다.",
        "detail":  "담당자가 인지 학습 꾸러미 및 인지 강화책을 제공한다."
    },
    {
        "goal":  "대상자가 치매환자의 특성을 이해하고 돌봄의 질을 향상할 수 있다.",
        "detail":  "담당자가 돌봄 로봇(효돌이 등) 지원 사업을 연계한다."
    },
    {
        "goal":  "대상자가 지남력을 향상할 수 있다.",
        "detail":  "담당자가 돌봄 로봇을 활용한 지남력 훈련을 제공한다."
    },
    {
        "goal":  "대상자가 규칙적인 식사 및 영양 습관을 가질 수 있다.",
        "detail":  "담당자가 돌봄 로봇의 복약 및 식사 알람 기능을 설정한다."
    },
    {
        "goal":  "대상자가 건강관리 인식을 향상할 수 있다.",
        "detail":  "담당자가 돌봄 로봇 인형의 사용법 교육 및 모니터링을 제공한다."
    },
    {
        "goal":  "대상자가 수면 양상을 정상화할 수 있다.",
        "detail":  "담당자가 전산 인지 프로그램 훈련을 제공한다."
    },
    {
        "goal":  "대상자가 음식물을 적절히 관리할 수 있다.",
        "detail":  "담당자가 치매 예방을 위한 뇌건강 리플릿을 제공한다."
    },
    {
        "goal":  "대상자가 개인위생 관리를 유지할 수 있다.",
        "detail":  "담당자가 지남력 향상을 위한 달력 및 뉴스 활용 활동을 지원한다."
    },
    {
        "goal":  "대상자가 식습관을 개선할 수 있다.",
        "detail":  "담당자가 협약 병원 진료 및 정기 검진을 연계한다."
    },
    {
        "goal":  "대상자가 신체 활동 능력을 증가시킬 수 있다.",
        "detail":  "담당자가 치매 관리 주치의 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 적절한 통증 관리를 할 수 있다.",
        "detail":  "담당자가 치매 안심 병동 및 안심 병원 입원 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 가용범위 내에서 신체의 잔존능력을 유지할 수 있다.",
        "detail":  "담당자가 재택 의료 센터 방문 진료 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 가용범위 내에서 신체 활동을 증진할 수 있다.",
        "detail":  "담당자가 일차의료 방문진료 수가 시범사업을 연계한다."
    },
    {
        "goal":  "대상자가 잔존 신체 능력을 유지할 수 있다.",
        "detail":  "담당자가 방문 간호 및 복약 지도 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 규칙적인 실내 체조를 통해 신체의 잔존능력을 유지할 수 있다.",
        "detail":  "담당자가 정신 건강 복지 센터 상담 및 교육 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 규칙적인 건강 체조로 잔존 신체 능력을 유지할 수 있다.",
        "detail":  "담당자가 우울증 선별 검사 및 정신건강 상담을 제공한다."
    },
    {
        "goal":  "대상자가 기력을 증진할 수 있다.",
        "detail":  "담당자가 방문 상담을 통한 말벗 서비스 및 정서적 지지를 제공한다."
    },
    {
        "goal":  "대상자가 스스로 신체 활동을 수행할 수 있다.",
        "detail":  "담당자가 비언어적 의사소통 방법 교육을 제공한다."
    },
    {
        "goal":  "대상자가 이동 시 낙상을 예방할 수 있다.",
        "detail":  "담당자가 신체 활동 운동 프로그램을 제공한다."
    },
    {
        "goal":  "대상자가 가동범위 내 신체 활동을 생활화할 수 있다.",
        "detail":  "담당자가 통합돌봄 방문 운동지도 사업을 연계한다."
    },
    {
        "goal":  "대상자가 관절 구축 및 하지 근력 약화를 예방할 수 있다.",
        "detail":  "담당자가 치매 예방 체조 및 건강 체조 포스터를 제공한다."
    },
    {
        "goal":  "대상자가 질병으로 인한 응급상황 발생을 감소시킬 수 있다.",
        "detail":  "담당자가 운동 보조 물품(스트레칭 밴드 등)을 제공한다."
    },
    {
        "goal":  "대상자가 관절 가동범위 운동으로 근육 구축을 방지할 수 있다.",
        "detail":  "담당자가 관절 가동 범위 운동법 교육 및 시범을 제공한다."
    },
    {
        "goal":  "대상자가 스스로 스트레칭을 할 수 있다.",
        "detail":  "담당자가 낙상 예방 보행법 및 하지 근력 운동 교육을 제공한다."
    },
    {
        "goal":  "대상자가 주기적인 산책을 할 수 있다.",
        "detail":  "담당자가 물리치료사의 스트레칭 교육을 지원한다."
    },
    {
        "goal":  "대상자가 치료 회복을 위해 매끼니 식사를 할 수 있다.",
        "detail":  "담당자가 영양 보조 음료 및 영양 음료를 제공한다."
    },
    {
        "goal":  "대상자가 부족한 영양을 보충할 수 있다.",
        "detail":  "담당자가 영양 개선을 위한 영양 죽을 제공한다."
    },
    {
        "goal":  "대상자가 영양 불균형을 해소할 수 있다.",
        "detail":  "담당자가 영양 보조식 지원 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 균형 잡힌 식사로 필요한 영양을 섭취할 수 있다.",
        "detail":  "담당자가 식사 배달 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 영양소를 골고루 섭취할 수 있다.",
        "detail":  "담당자가 밑반찬 지원 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 적절한 영양 식이 관리를 유지할 수 있다.",
        "detail":  "담당자가 적십자 밑반찬 지원 및 반찬 나눔 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 균형 잡힌 영양으로 신체 건강을 증진할 수 있다.",
        "detail":  "담당자가 푸드뱅크 식료품 및 생활 필수품 지원을 연계한다."
    },
    {
        "goal":  "대상자가 균형 잡힌 식사를 실시할 수 있다.",
        "detail":  "담당자가 영양 상태 모니터링 및 규칙적인 식습관 교육을 제공한다."
    },
    {
        "goal":  "대상자가 신체 건강을 유지할 수 있다.",
        "detail":  "담당자가 기저귀 및 위생 소모품 등 조호 물품을 제공한다."
    },
    {
        "goal":  "대상자가 주기적인 증상 관리를 유지할 수 있다.",
        "detail":  "담당자가 개인 위생용품(물티슈, 세정제 등)을 제공한다."
    },
    {
        "goal":  "대상자가 증상에 맞는 진료를 받을 수 있다.",
        "detail":  "담당자가 요실금 대처를 위한 위생용품 및 생활요법 교육을 제공한다."
    },
    {
        "goal":  "대상자가 수시로 침대에서 체위 변경을 할 수 있다.",
        "detail":  "담당자가 방문 목욕 및 목욕 차량 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 주기적인 신체 건강 관리를 할 수 있다.",
        "detail":  "담당자가 세탁 및 이불 세탁 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 신체 능력에 따른 필수적 운동을 수행할 수 있다.",
        "detail":  "담당자가 통증 관리 방법 및 통증 유발 요인 파악 교육을 제공한다."
    },
    {
        "goal":  "대상자가 신체 기능을 향상할 수 있다.",
        "detail":  "담당자가 수면 장애 개선을 위한 수면 양상 교육을 제공한다."
    },
    {
        "goal":  "대상자가 주기적 병원 방문을 통한 건강 상태를 유지할 수 있다.",
        "detail":  "담당자가 방문 건강 관리팀의 주기적인 건강 체크를 연계한다."
    },
    {
        "goal":  "대상자가 병의원 진료를 통해 건강을 유지할 수 있다.",
        "detail":  "담당자가 치매 치료 관리비 및 약제비 지원 신청을 연계한다."
    },
    {
        "goal":  "대상자가 질환 관리를 강화하여 유지할 수 있다.",
        "detail":  "담당자가 투약 관리를 위한 약 달력을 제공한다."
    },
    {
        "goal":  "대상자가 새로운 질병 이환을 예방할 수 있다.",
        "detail":  "담당자가 복용 약물 정리 및 보관함 지원 서비스를 제공한다."
    },
    {
        "goal":  "대상자가 자신의 건강 상태에 맞는 병의원을 이용할 수 있다.",
        "detail":  "담당자가 다제약물 관리 사업 연계를 지원한다."
    },
    {
        "goal":  "대상자가 앉았다 일어나기를 하루 10회 수행할 수 있다.",
        "detail":  "담당자가 치매 약물 복용의 중요성 및 순응도 교육을 제공한다."
    },
    {
        "goal":  "대상자가 질환 관리 및 심리 정서 교육 지원을 강화할 수 있다.",
        "detail":  "담당자가 일차의료 만성질환 관리 사업을 연계한다."
    },
    {
        "goal":  "대상자가 안전한 환경을 조성할 수 있다.",
        "detail":  "담당자가 노인 맞춤 돌봄 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 방문 목욕 서비스로 청결을 유지할 수 있다.",
        "detail":  "담당자가 긴급 복지 지원 및 생계비 지원 연계를 지원한다."
    },
    {
        "goal":  "대상자가 건강 이상 시 대처 방안을 마련할 수 있다.",
        "detail":  "담당자가 희망복지 지원단 및 읍면 사례관리팀 연계를 지원한다."
    },
    {
        "goal":  "대상자가 신체 기능 유지 증진 및 외출 기능을 향상할 수 있다.",
        "detail":  "담당자가 기초 연금 및 기초생활수급 관련 상담 및 연계를 지원한다."
    },
    {
        "goal":  "대상자가 규칙적인 식생활로 건강을 유지할 수 있다.",
        "detail":  "담당자가 노인 일자리 사업 및 시니어 클럽 연계를 지원한다."
    },
    {
        "goal":  "대상자가 질병을 예방할 수 있다.",
        "detail":  "담당자가 의료 급여 신청 서류 작성 보조 서비스를 지원한다."
    },
    {
        "goal":  "대상자가 건강에 대한 인식을 개선할 수 있다.",
        "detail":  "담당자가 배회 인식표 및 실종 대응 카드 제공을 지원한다."
    },
    {
        "goal":  "대상자가 합병증을 예방할 수 있다.",
        "detail":  "담당자가 배회 감지기(GPS) 제공 및 월 통신비 지원을 연계한다."
    },
    {
        "goal":  "대상자가 치매 환자 및 가족의 질환 관리와 진료 유지를 강화할 수 있다.",
        "detail":  "담당자가 경찰서 지문 등 사전 등록 연계를 지원한다."
    },
    {
        "goal":  "대상자가 치매 환자의 건강 관리를 할 수 있다.",
        "detail":  "담당자가 가스 안전 차단기(타이머콕) 설치를 지원한다."
    },
    {
        "goal":  "대상자가 주기적인 외래 진료를 받을 수 있다.",
        "detail":  "담당자가 화장실 안전 손잡이 및 안전바 설치를 지원한다."
    },
    {
        "goal":  "대상자가 치매 약물을 조기 복용할 수 있다.",
        "detail":  "담당자가 양변기 안전 손잡이 및 미끄럼 방지 매트를 제공한다."
    },
    {
        "goal":  "대상자가 치매 질환을 관리할 수 있다.",
        "detail":  "담당자가 가정용 소화기 제공 및 화재 예방 교육을 제공한다."
    },
    {
        "goal":  "대상자가 현재의 인지 상태를 유지할 수 있다.",
        "detail":  "담당자가 응급 안전 안심 서비스(응급벨) 연계를 지원한다."
    },
    {
        "goal":  "대상자가 우울감을 감소시킬 수 있다.",
        "detail":  "담당자가 청소 및 방역 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 돌봄 로봇을 활용하여 인지력을 향상할 수 있다.",
        "detail":  "담당자가 집안 정리 정돈 및 정리 수납 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 인지 기능 저하로 인한 사고를 예방할 수 있다.",
        "detail":  "담당자가 주거공간 건강 클린사업 연계를 지원한다."
    },
    {
        "goal":  "대상자가 정서적 안정을 가질 수 있다.",
        "detail":  "담당자가 고독사 예방을 위한 안부 확인 및 비상연락망 구축을 지원한다."
    },
    {
        "goal":  "대상자가 지남력을 유지할 수 있다.",
        "detail":  "담당자가 노인 보호 전문 기관 및 학대 예방 상담을 연계한다."
    },
    {
        "goal":  "대상자가 기억력 저하로 인한 일상생활의 어려움과 불편감을 감소시킬 수 있다.",
        "detail":  "담당자가 장기 요양 등급 신청 및 대리 접수를 지원한다."
    },
    {
        "goal":  "대상자가 돌봄 로봇 지원으로 인지 기능을 유지 및 향상할 수 있다.",
        "detail":  "담당자가 복지 용구(휠체어, 전동침대 등) 대여 및 구입을 연계한다."
    },
    {
        "goal":  "대상자가 인지 기능을 강화하고 스트레스를 해소할 수 있다.",
        "detail":  "담당자가 주간 보호 센터 신체 활동 프로그램 연계를 지원한다."
    },
    {
        "goal":  "대상자가 돌봄 로봇 이용을 통해 우울감을 감소시킬 수 있다.",
        "detail":  "담당자가 방문 요양 및 재가 서비스 센터 연계를 지원한다."
    },
    {
        "goal":  "대상자가 건강 상태를 파악하고 인지 기능을 유지할 수 있다.",
        "detail":  "담당자가 가사 간병 서비스 및 가사 지원 서비스 연계를 지원한다."
    },
    {
        "goal":  "대상자가 기억력 저하를 예방할 수 있다.",
        "detail":  "담당자가 교통약자 이동 지원 및 장애인 콜택시 신청을 연계한다."
    },
    {
        "goal":  "대상자가 인지 활동을 월 2회 이상 수행할 수 있다.",
        "detail":  "담당자가 통합돌봄 케어 택시 및 이동 동행 서비스를 연계한다."
    },
    {
        "goal":  "대상자가 인지 기능을 유지할 수 있다.",
        "detail":  "담당자가 주민자치센터 및 경로당 사회 참여 프로그램을 연계한다."
    },
    {
        "goal":  "대상자가 기억력 및 지남력의 현재 상태를 유지할 수 있다.",
        "detail":  "담당자가 공공 후견인 제도 및 후견 대상자 발굴 연계를 지원한다."
    },
    {
        "goal":  "대상자가 인지 기능 저하를 예방하고 현재 지남력을 유지할 수 있다.",
        "detail":  "담당자가 성년 후견 심판 청구 및 법률 상담 연계를 지원한다."
    },
    {
        "goal":  "대상자가 인지 기능을 유지 및 향상할 수 있다.",
        "detail":  "담당자가 무료 법률 지원 및 사무 관리 서비스를 지원한다."
    },
    {
        "goal":  "대상자가 건강 상태를 알고 인지 기능을 유지할 수 있다.",
        "detail":  "담당자가 치매 도서 대여 및 치매 독서 코너 이용을 지원한다."
    },
    {
        "goal":  "대상자가 인지 기능 훈련을 통한 잔존 능력을 개발 및 유지할 수 있다.",
        "detail":  "담당자가 헤아림 가족 교실 프로그램을 제공한다."
    },
    {
        "goal":  "대상자가 방문형 인지 키트를 활용하여 인지 기능을 향상할 수 있다.",
        "detail":  "담당자가 치매 가족 자조 모임 및 힐링 프로그램을 제공한다."
    },
    {
        "goal":  "대상자가 치매 대처 능력을 향상 및 유지할 수 있다.",
        "detail":  "담당자가 보호자 돌봄 부담 분석 검사 및 결과 상담을 제공한다."
    },
    {
        "goal":  "대상자가 정신적 부담을 경감할 수 있다.",
        "detail":  "담당자가 가족 심층 상담 및 정서적 지지 상담을 지원한다."
    },
    {
        "goal":  "대상자가 치매로 인한 심리 정서 행동을 관리할 수 있다.",
        "detail":  "담당자가 외부 기관 가족 프로그램 및 자조 모임 연계를 지원한다."
    },
    {
        "goal":  "대상자가 인지 기능 수준을 유지할 수 있다.",
        "detail":  "담당자가 치매 환자 돌봄 기술 및 정신행동증상 대처 교육을 제공한다."
    },
    {
        "goal":  "대상자가 심리적 안정감을 가질 수 있다.",
        "detail":  "담당자가 치매 가이드북 및 질환 인식 개선 교육 자료를 제공한다."
    },
    {
        "goal":  "대상자가 노인 의료 돌봄 통합 지원으로 인지 기능을 향상할 수 있다.",
        "detail":  "담당자가 치매 상담 전화 센터(1899-9988) 전문 상담을 연계한다."
    },
    {
        "goal":  "대상자가 병원에 대한 거부감을 감소시킬 수 있다.",
        "detail":  "담당자가 치매 가족 휴가제(단기 보호 서비스 등) 연계를 지원한다."
    },
    {
        "goal":  "대상자가 치매 및 동반 질환을 관리할 수 있다.",
        "detail":  "담당자가 보호자 건강 관리 상담 및 치료 연계 서비스를 제공한다."
    },
    {
        "goal":  "대상자가 인지 기능 유지 및 현 질병 상태의 악화를 방지할 수 있다.",
        "detail":  "담당자가 보호자 대상 신체 활동 수행 스티커 활용 교육을 제공한다."
    },
    {
        "goal":  "대상자가 스스로 투약 관리를 하여 인지 기능을 유지할 수 있다.",
        "detail":  "담당자가 지역 내 여가 시설 및 취미 교실 프로그램 연계를 지원한다."
    },
    {
        "goal":  "대상자가 인지 기능을 강화할 수 있다.",
        "detail":  "담당자가 노노케어 서비스 및 자원봉사자 연계 서비스를 지원한다."
    },
    {
        "goal":  "대상자가 일상생활 지원으로 치매 정도를 유지할 수 있다.",
        "detail":  "담당자가 길고양이 중성화 수술 등 생활 불편 민원 연계를 지원한다."
    },
    {
        "goal":  "대상자가 요양보호사와의 지속적인 접촉으로 인지 기능을 유지할 수 있다.",
        "detail":  "담당자가 치매 안심 센터 맞춤형 사례 관리 서비스를 제공한다."
    }
];
